// harvest these by filling out the forms, and then examine the redux state, pin, and choose `raw`
export const generalApplicationAnswers = [
  {
    questionInstance: {
      id: '72369',
      apiName: 'personal_information',
      displayName: 'Personal Information',
      label: 'Personal Information',
      helpText: null,
      component: 'repeatable',
      dataType: 'nested',
      propsBlob: {},
      required: false,
      askOnRenewal: false,
      prefillOnRenewal: false,
      subQuestions: [
        {
          id: '72370',
          apiName: 'first_name',
          displayName: 'First Name',
          label: 'First Name',
          helpText: null,
          component: 'textfield',
          dataType: 'string',
          propsBlob: {},
          required: true,
          askOnRenewal: false,
          prefillOnRenewal: false,
          subQuestions: [],
          defaultValue: '',
        },
        {
          id: '72371',
          apiName: 'last_name',
          displayName: 'Last Name',
          label: 'Last Name',
          helpText: null,
          component: 'textfield',
          dataType: 'string',
          propsBlob: {},
          required: true,
          askOnRenewal: false,
          prefillOnRenewal: false,
          subQuestions: [],
          defaultValue: '',
        },
        {
          id: '72372',
          apiName: 'date_of_birth',
          displayName: 'Date of Birth',
          label: 'Date of Birth',
          helpText: null,
          component: 'calendar',
          dataType: 'string',
          propsBlob: {},
          required: true,
          askOnRenewal: false,
          prefillOnRenewal: false,
          subQuestions: [],
          defaultValue: '',
        },
        {
          id: '72373',
          apiName: 'gender_sex_at_birth',
          displayName: 'Gender / Sex at Birth',
          label: 'Gender / Sex at Birth',
          helpText: null,
          component: 'InputToggle',
          dataType: 'string',
          propsBlob: {
            options: [
              {
                value: 'male',
                label: 'Male',
              },
              {
                value: 'female',
                label: 'Female',
              },
              {
                value: 'other',
                label: 'Other',
              },
            ],
          },
          required: true,
          askOnRenewal: false,
          prefillOnRenewal: false,
          subQuestions: [],
          defaultValue: '',
        },
        {
          id: '72374',
          apiName: 'education',
          displayName: 'Education',
          label: 'What is the highest level of education you have completed?',
          helpText: null,
          component: 'InputToggle',
          dataType: 'string',
          propsBlob: {
            options: [
              {
                value: 'No diploma',
                label: 'No diploma',
              },
              {
                value: 'Highschool or equivalent',
                label: 'Highschool or equivalent',
              },
              {
                value: 'Apprenticeship program',
                label: 'Apprenticeship program',
              },
              {
                value: 'College',
                label: 'College',
              },
              {
                value: 'Undergraduate certificate',
                label: 'Undergraduate certificate',
              },
              {
                value: 'Bachlors degree',
                label: 'Bachlors degree',
              },
              {
                value: 'Post graduate degree',
                label: 'Post graduate degree',
              },
            ],
          },
          required: true,
          askOnRenewal: false,
          prefillOnRenewal: false,
          subQuestions: [],
          defaultValue: '',
        },
        {
          id: '72375',
          apiName: 'marital_status',
          displayName: 'Marital Status',
          label: 'Marital Status',
          helpText: null,
          component: 'InputToggle',
          dataType: 'string',
          propsBlob: {
            options: [
              {
                value: 'Single',
                label: 'Single',
              },
              {
                value: 'Married',
                label: 'Married',
              },
              {
                value: 'Common-law',
                label: 'Common-law',
              },
              {
                value: 'Divorced',
                label: 'Divorced',
              },
              {
                value: 'Separated',
                label: 'Separated',
              },
              {
                value: 'Widowed',
                label: 'Widowed',
              },
            ],
          },
          required: true,
          askOnRenewal: false,
          prefillOnRenewal: false,
          subQuestions: [],
          defaultValue: '',
        },
        {
          id: '72376',
          apiName: 'primary_address',
          displayName: 'Primary Address',
          label: 'Primary Address',
          helpText: null,
          component: 'location',
          dataType: 'nested',
          propsBlob: {},
          required: false,
          askOnRenewal: false,
          prefillOnRenewal: false,
          subQuestions: [
            {
              id: '72377',
              apiName: 'address',
              displayName: 'address',
              label: 'Address',
              helpText: null,
              component: 'textfield',
              dataType: 'string',
              propsBlob: {},
              required: true,
              askOnRenewal: false,
              prefillOnRenewal: false,
              subQuestions: [],
              defaultValue: '',
            },
            {
              id: '72378',
              apiName: 'city',
              displayName: 'city',
              label: 'City',
              helpText: null,
              component: 'textfield',
              dataType: 'string',
              propsBlob: {},
              required: true,
              askOnRenewal: false,
              prefillOnRenewal: false,
              subQuestions: [],
              defaultValue: '',
            },
            {
              id: '72380',
              apiName: 'province',
              displayName: 'province',
              label: 'Province',
              helpText: null,
              component: 'textfield',
              dataType: 'string',
              propsBlob: {},
              required: true,
              askOnRenewal: false,
              prefillOnRenewal: false,
              subQuestions: [],
              defaultValue: '',
            },
            {
              id: '72382',
              apiName: 'postal',
              displayName: 'postal',
              label: 'Postal Code',
              helpText: null,
              component: 'textfield',
              dataType: 'string',
              propsBlob: {},
              required: true,
              askOnRenewal: false,
              prefillOnRenewal: false,
              subQuestions: [],
              defaultValue: '',
            },
          ],
          defaultValue: '',
        },
        {
          id: '72384',
          apiName: 'mailing_address',
          displayName: 'Mailing Address',
          label: 'Mailing Address',
          helpText: null,
          component: 'location',
          dataType: 'nested',
          propsBlob: {},
          required: false,
          askOnRenewal: false,
          prefillOnRenewal: false,
          subQuestions: [
            {
              id: '72386',
              apiName: 'address',
              displayName: 'address',
              label: 'Address',
              helpText: null,
              component: 'textfield',
              dataType: 'string',
              propsBlob: {},
              required: true,
              askOnRenewal: false,
              prefillOnRenewal: false,
              subQuestions: [],
              defaultValue: '',
            },
            {
              id: '72388',
              apiName: 'city',
              displayName: 'city',
              label: 'City',
              helpText: null,
              component: 'textfield',
              dataType: 'string',
              propsBlob: {},
              required: true,
              askOnRenewal: false,
              prefillOnRenewal: false,
              subQuestions: [],
              defaultValue: '',
            },
            {
              id: '72390',
              apiName: 'province',
              displayName: 'province',
              label: 'Province',
              helpText: null,
              component: 'textfield',
              dataType: 'string',
              propsBlob: {},
              required: true,
              askOnRenewal: false,
              prefillOnRenewal: false,
              subQuestions: [],
              defaultValue: '',
            },
            {
              id: '72392',
              apiName: 'postal',
              displayName: 'postal',
              label: 'Postal Code',
              helpText: null,
              component: 'textfield',
              dataType: 'string',
              propsBlob: {},
              required: true,
              askOnRenewal: false,
              prefillOnRenewal: false,
              subQuestions: [],
              defaultValue: '',
            },
          ],
          defaultValue: '',
        },
        {
          id: '72394',
          apiName: 'phone_number',
          displayName: 'Phone Number',
          label: 'Phone Number',
          helpText: null,
          component: 'phonefield',
          dataType: 'string',
          propsBlob: {},
          required: true,
          askOnRenewal: false,
          prefillOnRenewal: false,
          subQuestions: [],
          defaultValue: '',
        },
        {
          id: '72395',
          apiName: 'contact_email',
          displayName: 'Email',
          label: 'Email',
          helpText: null,
          component: 'emailinput',
          dataType: 'string',
          propsBlob: {},
          required: true,
          askOnRenewal: false,
          prefillOnRenewal: false,
          subQuestions: [],
          defaultValue: '',
        },
        {
          id: '72396',
          apiName: 'identification',
          displayName: 'Identification',
          label: 'Identification',
          helpText: null,
          component: 'repeatable',
          dataType: 'nested',
          propsBlob: {},
          required: false,
          askOnRenewal: false,
          prefillOnRenewal: false,
          subQuestions: [
            {
              id: '72397',
              apiName: 'identification_type',
              displayName: 'Identification Type',
              label: 'Type',
              helpText: null,
              component: 'InputToggle',
              dataType: 'string',
              propsBlob: {
                options: [
                  {
                    value: "Driver's Licence",
                    label: "Driver's Licence",
                  },
                  {
                    value: 'Passport',
                    label: 'Passport',
                  },
                  {
                    value: 'Citizenship',
                    label: 'Citizenship Card',
                  },
                  {
                    value: 'Permanent Resident Card',
                    label: 'Permanent Resident Card',
                  },
                  {
                    value: 'Province Identification Card',
                    label: 'Province Identification Card',
                  },
                  {
                    value: 'Birth Certificate',
                    label: 'Birth Certificate',
                  },
                ],
              },
              required: true,
              askOnRenewal: false,
              prefillOnRenewal: false,
              subQuestions: [],
              defaultValue: '',
            },
            {
              id: '72399',
              apiName: 'identification_province_of_issue',
              displayName: 'Identification Province of Issue',
              label: 'Province of Issue',
              helpText: null,
              component: 'InputToggle',
              dataType: 'string',
              propsBlob: {
                options: [
                  {
                    value: 'Alberta',
                    label: 'Alberta',
                  },
                  {
                    value: 'British Columbia',
                    label: 'British Columbia',
                  },
                  {
                    value: 'Manitoba',
                    label: 'Manitoba',
                  },
                  {
                    value: 'New Brunswick',
                    label: 'New Brunswick',
                  },
                  {
                    value: 'Newfoundland and Labrador',
                    label: 'Newfoundland and Labrador',
                  },
                  {
                    value: 'Northwest Territories',
                    label: 'Northwest Territories',
                  },
                  {
                    value: 'Nova Scotia',
                    label: 'Nova Scotia',
                  },
                  {
                    value: 'Nunavut',
                    label: 'Nunavut',
                  },
                  {
                    value: 'Ontario',
                    label: 'Ontario',
                  },
                  {
                    value: 'Prince Edward Island',
                    label: 'Prince Edward Island',
                  },
                  {
                    value: 'Quebec',
                    label: 'Quebec',
                  },
                  {
                    value: 'Saskatchewan',
                    label: 'Saskatchewan',
                  },
                  {
                    value: 'Yukon',
                    label: 'Yukon',
                  },
                ],
              },
              required: true,
              askOnRenewal: false,
              prefillOnRenewal: false,
              subQuestions: [],
              defaultValue: '',
            },
            {
              id: '72401',
              apiName: 'identification_number',
              displayName: 'Identification Number',
              label: 'Number',
              helpText: null,
              component: 'textfield',
              dataType: 'string',
              propsBlob: {},
              required: true,
              askOnRenewal: false,
              prefillOnRenewal: false,
              subQuestions: [],
              defaultValue: '',
            },
            {
              id: '72402',
              apiName: 'identification_expiry_date',
              displayName: 'Identification Expiry Date',
              label: 'Expiry Date',
              helpText: null,
              component: 'calendar',
              dataType: 'string',
              propsBlob: {},
              required: true,
              askOnRenewal: false,
              prefillOnRenewal: false,
              subQuestions: [],
              defaultValue: '',
            },
          ],
          defaultValue: '',
        },
        {
          id: '72405',
          apiName: 'citizenship_conditional',
          displayName: 'Citizenship Conditional',
          label: 'Citizenship Conditional',
          helpText: null,
          component: 'multibranchedLogic',
          dataType: 'nested',
          propsBlob: {
            conditions: [
              {
                api_name: 'citizenship_residency_status_other',
                operator: 'equals',
                condition: 'other',
              },
              {
                api_name: 'permanent_resident_time_frame',
                operator: 'equals',
                condition: 'Permanent Resident',
              },
            ],
          },
          required: false,
          askOnRenewal: false,
          prefillOnRenewal: false,
          subQuestions: [
            {
              id: '72407',
              apiName: 'citizenship_residency_status',
              displayName: 'Citizenship / Residency Status',
              label: 'Citizenship / Residency Status in Canada',
              helpText: null,
              component: 'InputToggle',
              dataType: 'string',
              propsBlob: {
                options: [
                  {
                    value: 'Canadian Citizen',
                    label: 'Canadian Citizen',
                  },
                  {
                    value: 'Permanent Resident',
                    label: 'Permanent Resident',
                  },
                  {
                    value: 'other',
                    label: 'Other',
                  },
                ],
              },
              required: true,
              askOnRenewal: false,
              prefillOnRenewal: false,
              subQuestions: [],
              defaultValue: '',
            },
            {
              id: '72409',
              apiName: 'citizenship_residency_status_other',
              displayName: 'Citizenship / Residency Status - Other',
              label: 'Please Specify',
              helpText: null,
              component: 'textfield',
              dataType: 'string',
              propsBlob: {},
              required: true,
              askOnRenewal: false,
              prefillOnRenewal: false,
              subQuestions: [],
              defaultValue: '',
            },
            {
              id: '72410',
              apiName: 'permanent_resident_time_frame',
              displayName: 'Permanent Resident Time Frame',
              label: 'How long have you resided in Canada?',
              helpText: null,
              component: 'InputToggle',
              dataType: 'string',
              propsBlob: {
                options: [
                  {
                    value: 'More than 12 months',
                    label: 'More than 12 months',
                  },
                  {
                    value: 'Less than 12 months',
                    label: 'Less than 12 months',
                  },
                ],
              },
              required: true,
              askOnRenewal: false,
              prefillOnRenewal: false,
              subQuestions: [],
              defaultValue: '',
            },
          ],
          defaultValue: '',
        },
        {
          id: '72413',
          apiName: 'countries_conditional',
          displayName: 'Countries Conditional',
          label: 'Country of Birth',
          helpText: null,
          component: 'multibranchedLogic',
          dataType: 'nested',
          propsBlob: {
            conditions: [
              {
                api_name: 'province',
                operator: 'equals',
                condition: 'Canada',
              },
              {
                not: true,
                api_name: 'date_of_arrival_in_canada',
                operator: 'equals',
                condition: 'Canada',
              },
            ],
          },
          required: false,
          askOnRenewal: false,
          prefillOnRenewal: false,
          subQuestions: [
            {
              id: '72414',
              apiName: 'country_of_birth',
              displayName: 'Country of Birth',
              label: 'Country of Birth',
              helpText: null,
              component: 'countryDropdown',
              dataType: 'string',
              propsBlob: {},
              required: true,
              askOnRenewal: false,
              prefillOnRenewal: false,
              subQuestions: [],
              defaultValue: '',
            },
            {
              id: '72416',
              apiName: 'date_of_arrival_in_canada',
              displayName: 'Date of Arrival In Canada',
              label: 'Date of Arrival In Canada',
              helpText: null,
              component: 'calendar',
              dataType: 'string',
              propsBlob: {},
              required: true,
              askOnRenewal: false,
              prefillOnRenewal: false,
              subQuestions: [],
              defaultValue: '',
            },
            {
              id: '72417',
              apiName: 'province',
              displayName: 'Province',
              label: 'Province of Birth',
              helpText: null,
              component: 'InputToggle',
              dataType: 'string',
              propsBlob: {
                options: [
                  {
                    value: 'Alberta',
                    label: 'Alberta',
                  },
                  {
                    value: 'British Columbia',
                    label: 'British Columbia',
                  },
                  {
                    value: 'Manitoba',
                    label: 'Manitoba',
                  },
                  {
                    value: 'New Brunswick',
                    label: 'New Brunswick',
                  },
                  {
                    value: 'Newfoundland and Labrador',
                    label: 'Newfoundland and Labrador',
                  },
                  {
                    value: 'Northwest Territories',
                    label: 'Northwest Territories',
                  },
                  {
                    value: 'Nova Scotia',
                    label: 'Nova Scotia',
                  },
                  {
                    value: 'Nunavut',
                    label: 'Nunavut',
                  },
                  {
                    value: 'Ontario',
                    label: 'Ontario',
                  },
                  {
                    value: 'Prince Edward Island',
                    label: 'Prince Edward Island',
                  },
                  {
                    value: 'Quebec',
                    label: 'Quebec',
                  },
                  {
                    value: 'Saskatchewan',
                    label: 'Saskatchewan',
                  },
                  {
                    value: 'Yukon',
                    label: 'Yukon',
                  },
                ],
              },
              required: true,
              askOnRenewal: false,
              prefillOnRenewal: false,
              subQuestions: [],
              defaultValue: '',
            },
          ],
          defaultValue: '',
        },
      ],
      defaultValue: '',
    },
    value: 1,
    subAnswers: [
      {
        questionInstance: {
          id: '72372',
          apiName: 'date_of_birth',
          displayName: 'Date of Birth',
          label: 'Date of Birth',
          helpText: null,
          component: 'calendar',
          dataType: 'string',
          propsBlob: {},
          required: true,
          askOnRenewal: false,
          prefillOnRenewal: false,
          subQuestions: [],
          defaultValue: '',
        },
        value: '07/31/1993',
        subAnswers: [],
        details: {
          lat: null,
          lng: null,
          google: {},
          opta: {},
          openingHours: [],
          images: [],
        },
      },
      {
        questionInstance: {
          id: '72373',
          apiName: 'gender_sex_at_birth',
          displayName: 'Gender / Sex at Birth',
          label: 'Gender / Sex at Birth',
          helpText: null,
          component: 'InputToggle',
          dataType: 'string',
          propsBlob: {
            options: [
              {
                value: 'male',
                label: 'Male',
              },
              {
                value: 'female',
                label: 'Female',
              },
              {
                value: 'other',
                label: 'Other',
              },
            ],
          },
          required: true,
          askOnRenewal: false,
          prefillOnRenewal: false,
          subQuestions: [],
          defaultValue: '',
        },
        value: 'female',
        subAnswers: [],
        details: {
          lat: null,
          lng: null,
          google: {},
          opta: {},
          openingHours: [],
          images: [],
        },
      },
      {
        questionInstance: {
          id: '72374',
          apiName: 'education',
          displayName: 'Education',
          label: 'What is the highest level of education you have completed?',
          helpText: null,
          component: 'InputToggle',
          dataType: 'string',
          propsBlob: {
            options: [
              {
                value: 'No diploma',
                label: 'No diploma',
              },
              {
                value: 'Highschool or equivalent',
                label: 'Highschool or equivalent',
              },
              {
                value: 'Apprenticeship program',
                label: 'Apprenticeship program',
              },
              {
                value: 'College',
                label: 'College',
              },
              {
                value: 'Undergraduate certificate',
                label: 'Undergraduate certificate',
              },
              {
                value: 'Bachlors degree',
                label: 'Bachlors degree',
              },
              {
                value: 'Post graduate degree',
                label: 'Post graduate degree',
              },
            ],
          },
          required: true,
          askOnRenewal: false,
          prefillOnRenewal: false,
          subQuestions: [],
          defaultValue: '',
        },
        value: 'Undergraduate certificate',
        subAnswers: [],
        details: {
          lat: null,
          lng: null,
          google: {},
          opta: {},
          openingHours: [],
          images: [],
        },
      },
      {
        questionInstance: {
          id: '72375',
          apiName: 'marital_status',
          displayName: 'Marital Status',
          label: 'Marital Status',
          helpText: null,
          component: 'InputToggle',
          dataType: 'string',
          propsBlob: {
            options: [
              {
                value: 'Single',
                label: 'Single',
              },
              {
                value: 'Married',
                label: 'Married',
              },
              {
                value: 'Common-law',
                label: 'Common-law',
              },
              {
                value: 'Divorced',
                label: 'Divorced',
              },
              {
                value: 'Separated',
                label: 'Separated',
              },
              {
                value: 'Widowed',
                label: 'Widowed',
              },
            ],
          },
          required: true,
          askOnRenewal: false,
          prefillOnRenewal: false,
          subQuestions: [],
          defaultValue: '',
        },
        value: 'Married',
        subAnswers: [],
        details: {
          lat: null,
          lng: null,
          google: {},
          opta: {},
          openingHours: [],
          images: [],
        },
      },
      {
        questionInstance: {
          id: '72376',
          apiName: 'primary_address',
          displayName: 'Primary Address',
          label: 'Primary Address',
          helpText: null,
          component: 'location',
          dataType: 'nested',
          propsBlob: {},
          required: false,
          askOnRenewal: false,
          prefillOnRenewal: false,
          subQuestions: [
            {
              id: '72377',
              apiName: 'address',
              displayName: 'address',
              label: 'Address',
              helpText: null,
              component: 'textfield',
              dataType: 'string',
              propsBlob: {},
              required: true,
              askOnRenewal: false,
              prefillOnRenewal: false,
              subQuestions: [],
              defaultValue: '',
            },
            {
              id: '72378',
              apiName: 'city',
              displayName: 'city',
              label: 'City',
              helpText: null,
              component: 'textfield',
              dataType: 'string',
              propsBlob: {},
              required: true,
              askOnRenewal: false,
              prefillOnRenewal: false,
              subQuestions: [],
              defaultValue: '',
            },
            {
              id: '72380',
              apiName: 'province',
              displayName: 'province',
              label: 'Province',
              helpText: null,
              component: 'textfield',
              dataType: 'string',
              propsBlob: {},
              required: true,
              askOnRenewal: false,
              prefillOnRenewal: false,
              subQuestions: [],
              defaultValue: '',
            },
            {
              id: '72382',
              apiName: 'postal',
              displayName: 'postal',
              label: 'Postal Code',
              helpText: null,
              component: 'textfield',
              dataType: 'string',
              propsBlob: {},
              required: true,
              askOnRenewal: false,
              prefillOnRenewal: false,
              subQuestions: [],
              defaultValue: '',
            },
          ],
          defaultValue: '',
        },
        value: '1',
        subAnswers: [
          {
            questionInstance: {
              id: '72377',
              apiName: 'address',
              displayName: 'address',
              label: 'Address',
              helpText: null,
              component: 'textfield',
              dataType: 'string',
              propsBlob: {},
              required: true,
              askOnRenewal: false,
              prefillOnRenewal: false,
              subQuestions: [],
              defaultValue: '',
            },
            value: '123 Example Street',
            subAnswers: [],
            details: {
              lat: null,
              lng: null,
              google: {},
              opta: {},
              openingHours: [],
              images: [],
            },
          },
          {
            questionInstance: {
              id: '72378',
              apiName: 'city',
              displayName: 'city',
              label: 'City',
              helpText: null,
              component: 'textfield',
              dataType: 'string',
              propsBlob: {},
              required: true,
              askOnRenewal: false,
              prefillOnRenewal: false,
              subQuestions: [],
              defaultValue: '',
            },
            value: 'Vancouver',
            subAnswers: [],
            details: {
              lat: null,
              lng: null,
              google: {},
              opta: {},
              openingHours: [],
              images: [],
            },
          },
          {
            questionInstance: {
              id: '72380',
              apiName: 'province',
              displayName: 'province',
              label: 'Province',
              helpText: null,
              component: 'textfield',
              dataType: 'string',
              propsBlob: {},
              required: true,
              askOnRenewal: false,
              prefillOnRenewal: false,
              subQuestions: [],
              defaultValue: '',
            },
            value: 'BC',
            subAnswers: [],
            details: {
              lat: null,
              lng: null,
              google: {},
              opta: {},
              openingHours: [],
              images: [],
            },
          },
          {
            questionInstance: {
              id: '72382',
              apiName: 'postal',
              displayName: 'postal',
              label: 'Postal Code',
              helpText: null,
              component: 'textfield',
              dataType: 'string',
              propsBlob: {},
              required: true,
              askOnRenewal: false,
              prefillOnRenewal: false,
              subQuestions: [],
              defaultValue: '',
            },
            value: 'T1V1J6',
            subAnswers: [],
            details: {
              lat: null,
              lng: null,
              google: {},
              opta: {},
              openingHours: [],
              images: [],
            },
          },
        ],
        details: {
          lat: null,
          lng: null,
          google: {},
          opta: {},
          openingHours: [],
          images: [],
        },
      },
      {
        questionInstance: {
          id: '72384',
          apiName: 'mailing_address',
          displayName: 'Mailing Address',
          label: 'Mailing Address',
          helpText: null,
          component: 'location',
          dataType: 'nested',
          propsBlob: {},
          required: false,
          askOnRenewal: false,
          prefillOnRenewal: false,
          subQuestions: [
            {
              id: '72386',
              apiName: 'address',
              displayName: 'address',
              label: 'Address',
              helpText: null,
              component: 'textfield',
              dataType: 'string',
              propsBlob: {},
              required: true,
              askOnRenewal: false,
              prefillOnRenewal: false,
              subQuestions: [],
              defaultValue: '',
            },
            {
              id: '72388',
              apiName: 'city',
              displayName: 'city',
              label: 'City',
              helpText: null,
              component: 'textfield',
              dataType: 'string',
              propsBlob: {},
              required: true,
              askOnRenewal: false,
              prefillOnRenewal: false,
              subQuestions: [],
              defaultValue: '',
            },
            {
              id: '72390',
              apiName: 'province',
              displayName: 'province',
              label: 'Province',
              helpText: null,
              component: 'textfield',
              dataType: 'string',
              propsBlob: {},
              required: true,
              askOnRenewal: false,
              prefillOnRenewal: false,
              subQuestions: [],
              defaultValue: '',
            },
            {
              id: '72392',
              apiName: 'postal',
              displayName: 'postal',
              label: 'Postal Code',
              helpText: null,
              component: 'textfield',
              dataType: 'string',
              propsBlob: {},
              required: true,
              askOnRenewal: false,
              prefillOnRenewal: false,
              subQuestions: [],
              defaultValue: '',
            },
          ],
          defaultValue: '',
        },
        value: '1',
        subAnswers: [
          {
            questionInstance: {
              id: '72386',
              apiName: 'address',
              displayName: 'address',
              label: 'Address',
              helpText: null,
              component: 'textfield',
              dataType: 'string',
              propsBlob: {},
              required: true,
              askOnRenewal: false,
              prefillOnRenewal: false,
              subQuestions: [],
              defaultValue: '',
            },
            value: '123 Example Street',
            subAnswers: [],
            details: {
              lat: null,
              lng: null,
              google: {},
              opta: {},
              openingHours: [],
              images: [],
            },
          },
          {
            questionInstance: {
              id: '72388',
              apiName: 'city',
              displayName: 'city',
              label: 'City',
              helpText: null,
              component: 'textfield',
              dataType: 'string',
              propsBlob: {},
              required: true,
              askOnRenewal: false,
              prefillOnRenewal: false,
              subQuestions: [],
              defaultValue: '',
            },
            value: 'Vancouver',
            subAnswers: [],
            details: {
              lat: null,
              lng: null,
              google: {},
              opta: {},
              openingHours: [],
              images: [],
            },
          },
          {
            questionInstance: {
              id: '72390',
              apiName: 'province',
              displayName: 'province',
              label: 'Province',
              helpText: null,
              component: 'textfield',
              dataType: 'string',
              propsBlob: {},
              required: true,
              askOnRenewal: false,
              prefillOnRenewal: false,
              subQuestions: [],
              defaultValue: '',
            },
            value: 'BC',
            subAnswers: [],
            details: {
              lat: null,
              lng: null,
              google: {},
              opta: {},
              openingHours: [],
              images: [],
            },
          },
          {
            questionInstance: {
              id: '72392',
              apiName: 'postal',
              displayName: 'postal',
              label: 'Postal Code',
              helpText: null,
              component: 'textfield',
              dataType: 'string',
              propsBlob: {},
              required: true,
              askOnRenewal: false,
              prefillOnRenewal: false,
              subQuestions: [],
              defaultValue: '',
            },
            value: 'T1V1J6',
            subAnswers: [],
            details: {
              lat: null,
              lng: null,
              google: {},
              opta: {},
              openingHours: [],
              images: [],
            },
          },
        ],
        details: {
          lat: null,
          lng: null,
          google: {},
          opta: {},
          openingHours: [],
          images: [],
        },
      },
      {
        questionInstance: {
          id: '72394',
          apiName: 'phone_number',
          displayName: 'Phone Number',
          label: 'Phone Number',
          helpText: null,
          component: 'phonefield',
          dataType: 'string',
          propsBlob: {},
          required: true,
          askOnRenewal: false,
          prefillOnRenewal: false,
          subQuestions: [],
          defaultValue: '',
        },
        value: '+1 (403) 909-4399',
        subAnswers: [],
        details: {
          lat: null,
          lng: null,
          google: {},
          opta: {},
          openingHours: [],
          images: [],
        },
      },
      {
        questionInstance: {
          id: '72396',
          apiName: 'identification',
          displayName: 'Identification',
          label: 'Identification',
          helpText: null,
          component: 'repeatable',
          dataType: 'nested',
          propsBlob: {},
          required: false,
          askOnRenewal: false,
          prefillOnRenewal: false,
          subQuestions: [
            {
              id: '72397',
              apiName: 'identification_type',
              displayName: 'Identification Type',
              label: 'Type',
              helpText: null,
              component: 'InputToggle',
              dataType: 'string',
              propsBlob: {
                options: [
                  {
                    value: "Driver's Licence",
                    label: "Driver's Licence",
                  },
                  {
                    value: 'Passport',
                    label: 'Passport',
                  },
                  {
                    value: 'Citizenship',
                    label: 'Citizenship Card',
                  },
                  {
                    value: 'Permanent Resident Card',
                    label: 'Permanent Resident Card',
                  },
                  {
                    value: 'Province Identification Card',
                    label: 'Province Identification Card',
                  },
                  {
                    value: 'Birth Certificate',
                    label: 'Birth Certificate',
                  },
                ],
              },
              required: true,
              askOnRenewal: false,
              prefillOnRenewal: false,
              subQuestions: [],
              defaultValue: '',
            },
            {
              id: '72399',
              apiName: 'identification_province_of_issue',
              displayName: 'Identification Province of Issue',
              label: 'Province of Issue',
              helpText: null,
              component: 'InputToggle',
              dataType: 'string',
              propsBlob: {
                options: [
                  {
                    value: 'Alberta',
                    label: 'Alberta',
                  },
                  {
                    value: 'British Columbia',
                    label: 'British Columbia',
                  },
                  {
                    value: 'Manitoba',
                    label: 'Manitoba',
                  },
                  {
                    value: 'New Brunswick',
                    label: 'New Brunswick',
                  },
                  {
                    value: 'Newfoundland and Labrador',
                    label: 'Newfoundland and Labrador',
                  },
                  {
                    value: 'Northwest Territories',
                    label: 'Northwest Territories',
                  },
                  {
                    value: 'Nova Scotia',
                    label: 'Nova Scotia',
                  },
                  {
                    value: 'Nunavut',
                    label: 'Nunavut',
                  },
                  {
                    value: 'Ontario',
                    label: 'Ontario',
                  },
                  {
                    value: 'Prince Edward Island',
                    label: 'Prince Edward Island',
                  },
                  {
                    value: 'Quebec',
                    label: 'Quebec',
                  },
                  {
                    value: 'Saskatchewan',
                    label: 'Saskatchewan',
                  },
                  {
                    value: 'Yukon',
                    label: 'Yukon',
                  },
                ],
              },
              required: true,
              askOnRenewal: false,
              prefillOnRenewal: false,
              subQuestions: [],
              defaultValue: '',
            },
            {
              id: '72401',
              apiName: 'identification_number',
              displayName: 'Identification Number',
              label: 'Number',
              helpText: null,
              component: 'textfield',
              dataType: 'string',
              propsBlob: {},
              required: true,
              askOnRenewal: false,
              prefillOnRenewal: false,
              subQuestions: [],
              defaultValue: '',
            },
            {
              id: '72402',
              apiName: 'identification_expiry_date',
              displayName: 'Identification Expiry Date',
              label: 'Expiry Date',
              helpText: null,
              component: 'calendar',
              dataType: 'string',
              propsBlob: {},
              required: true,
              askOnRenewal: false,
              prefillOnRenewal: false,
              subQuestions: [],
              defaultValue: '',
            },
          ],
          defaultValue: '',
        },
        value: 1,
        subAnswers: [
          {
            questionInstance: {
              id: '72397',
              apiName: 'identification_type',
              displayName: 'Identification Type',
              label: 'Type',
              helpText: null,
              component: 'InputToggle',
              dataType: 'string',
              propsBlob: {
                options: [
                  {
                    value: "Driver's Licence",
                    label: "Driver's Licence",
                  },
                  {
                    value: 'Passport',
                    label: 'Passport',
                  },
                  {
                    value: 'Citizenship',
                    label: 'Citizenship Card',
                  },
                  {
                    value: 'Permanent Resident Card',
                    label: 'Permanent Resident Card',
                  },
                  {
                    value: 'Province Identification Card',
                    label: 'Province Identification Card',
                  },
                  {
                    value: 'Birth Certificate',
                    label: 'Birth Certificate',
                  },
                ],
              },
              required: true,
              askOnRenewal: false,
              prefillOnRenewal: false,
              subQuestions: [],
              defaultValue: '',
            },
            value: "Driver's Licence",
            subAnswers: [],
            details: {
              lat: null,
              lng: null,
              google: {},
              opta: {},
              openingHours: [],
              images: [],
            },
          },
          {
            questionInstance: {
              id: '72399',
              apiName: 'identification_province_of_issue',
              displayName: 'Identification Province of Issue',
              label: 'Province of Issue',
              helpText: null,
              component: 'InputToggle',
              dataType: 'string',
              propsBlob: {
                options: [
                  {
                    value: 'Alberta',
                    label: 'Alberta',
                  },
                  {
                    value: 'British Columbia',
                    label: 'British Columbia',
                  },
                  {
                    value: 'Manitoba',
                    label: 'Manitoba',
                  },
                  {
                    value: 'New Brunswick',
                    label: 'New Brunswick',
                  },
                  {
                    value: 'Newfoundland and Labrador',
                    label: 'Newfoundland and Labrador',
                  },
                  {
                    value: 'Northwest Territories',
                    label: 'Northwest Territories',
                  },
                  {
                    value: 'Nova Scotia',
                    label: 'Nova Scotia',
                  },
                  {
                    value: 'Nunavut',
                    label: 'Nunavut',
                  },
                  {
                    value: 'Ontario',
                    label: 'Ontario',
                  },
                  {
                    value: 'Prince Edward Island',
                    label: 'Prince Edward Island',
                  },
                  {
                    value: 'Quebec',
                    label: 'Quebec',
                  },
                  {
                    value: 'Saskatchewan',
                    label: 'Saskatchewan',
                  },
                  {
                    value: 'Yukon',
                    label: 'Yukon',
                  },
                ],
              },
              required: true,
              askOnRenewal: false,
              prefillOnRenewal: false,
              subQuestions: [],
              defaultValue: '',
            },
            value: 'British Columbia',
            subAnswers: [],
            details: {
              lat: null,
              lng: null,
              google: {},
              opta: {},
              openingHours: [],
              images: [],
            },
          },
          {
            questionInstance: {
              id: '72401',
              apiName: 'identification_number',
              displayName: 'Identification Number',
              label: 'Number',
              helpText: null,
              component: 'textfield',
              dataType: 'string',
              propsBlob: {},
              required: true,
              askOnRenewal: false,
              prefillOnRenewal: false,
              subQuestions: [],
              defaultValue: '',
            },
            value: '123456789',
            subAnswers: [],
            details: {
              lat: null,
              lng: null,
              google: {},
              opta: {},
              openingHours: [],
              images: [],
            },
          },
          {
            questionInstance: {
              id: '72402',
              apiName: 'identification_expiry_date',
              displayName: 'Identification Expiry Date',
              label: 'Expiry Date',
              helpText: null,
              component: 'calendar',
              dataType: 'string',
              propsBlob: {},
              required: true,
              askOnRenewal: false,
              prefillOnRenewal: false,
              subQuestions: [],
              defaultValue: '',
            },
            value: '07/12/2029',
            subAnswers: [],
            details: {
              lat: null,
              lng: null,
              google: {},
              opta: {},
              openingHours: [],
              images: [],
            },
          },
        ],
        details: {
          lat: null,
          lng: null,
          google: {},
          opta: {},
          openingHours: [],
          images: [],
        },
      },
      {
        questionInstance: {
          id: '72405',
          apiName: 'citizenship_conditional',
          displayName: 'Citizenship Conditional',
          label: 'Citizenship Conditional',
          helpText: null,
          component: 'multibranchedLogic',
          dataType: 'nested',
          propsBlob: {
            conditions: [
              {
                api_name: 'citizenship_residency_status_other',
                operator: 'equals',
                condition: 'other',
              },
              {
                api_name: 'permanent_resident_time_frame',
                operator: 'equals',
                condition: 'Permanent Resident',
              },
            ],
          },
          required: false,
          askOnRenewal: false,
          prefillOnRenewal: false,
          subQuestions: [
            {
              id: '72407',
              apiName: 'citizenship_residency_status',
              displayName: 'Citizenship / Residency Status',
              label: 'Citizenship / Residency Status in Canada',
              helpText: null,
              component: 'InputToggle',
              dataType: 'string',
              propsBlob: {
                options: [
                  {
                    value: 'Canadian Citizen',
                    label: 'Canadian Citizen',
                  },
                  {
                    value: 'Permanent Resident',
                    label: 'Permanent Resident',
                  },
                  {
                    value: 'other',
                    label: 'Other',
                  },
                ],
              },
              required: true,
              askOnRenewal: false,
              prefillOnRenewal: false,
              subQuestions: [],
              defaultValue: '',
            },
            {
              id: '72409',
              apiName: 'citizenship_residency_status_other',
              displayName: 'Citizenship / Residency Status - Other',
              label: 'Please Specify',
              helpText: null,
              component: 'textfield',
              dataType: 'string',
              propsBlob: {},
              required: true,
              askOnRenewal: false,
              prefillOnRenewal: false,
              subQuestions: [],
              defaultValue: '',
            },
            {
              id: '72410',
              apiName: 'permanent_resident_time_frame',
              displayName: 'Permanent Resident Time Frame',
              label: 'How long have you resided in Canada?',
              helpText: null,
              component: 'InputToggle',
              dataType: 'string',
              propsBlob: {
                options: [
                  {
                    value: 'More than 12 months',
                    label: 'More than 12 months',
                  },
                  {
                    value: 'Less than 12 months',
                    label: 'Less than 12 months',
                  },
                ],
              },
              required: true,
              askOnRenewal: false,
              prefillOnRenewal: false,
              subQuestions: [],
              defaultValue: '',
            },
          ],
          defaultValue: '',
        },
        value: '1',
        subAnswers: [
          {
            questionInstance: {
              id: '72407',
              apiName: 'citizenship_residency_status',
              displayName: 'Citizenship / Residency Status',
              label: 'Citizenship / Residency Status in Canada',
              helpText: null,
              component: 'InputToggle',
              dataType: 'string',
              propsBlob: {
                options: [
                  {
                    value: 'Canadian Citizen',
                    label: 'Canadian Citizen',
                  },
                  {
                    value: 'Permanent Resident',
                    label: 'Permanent Resident',
                  },
                  {
                    value: 'other',
                    label: 'Other',
                  },
                ],
              },
              required: true,
              askOnRenewal: false,
              prefillOnRenewal: false,
              subQuestions: [],
              defaultValue: '',
            },
            value: 'Permanent Resident',
            subAnswers: [],
            details: {
              lat: null,
              lng: null,
              google: {},
              opta: {},
              openingHours: [],
              images: [],
            },
          },
          {
            questionInstance: {
              id: '72410',
              apiName: 'permanent_resident_time_frame',
              displayName: 'Permanent Resident Time Frame',
              label: 'How long have you resided in Canada?',
              helpText: null,
              component: 'InputToggle',
              dataType: 'string',
              propsBlob: {
                options: [
                  {
                    value: 'More than 12 months',
                    label: 'More than 12 months',
                  },
                  {
                    value: 'Less than 12 months',
                    label: 'Less than 12 months',
                  },
                ],
              },
              required: true,
              askOnRenewal: false,
              prefillOnRenewal: false,
              subQuestions: [],
              defaultValue: '',
            },
            value: 'More than 12 months',
            subAnswers: [],
            details: {
              lat: null,
              lng: null,
              google: {},
              opta: {},
              openingHours: [],
              images: [],
            },
          },
        ],
        details: {
          lat: null,
          lng: null,
          google: {},
          opta: {},
          openingHours: [],
          images: [],
        },
      },
      {
        questionInstance: {
          id: '72413',
          apiName: 'countries_conditional',
          displayName: 'Countries Conditional',
          label: 'Country of Birth',
          helpText: null,
          component: 'multibranchedLogic',
          dataType: 'nested',
          propsBlob: {
            conditions: [
              {
                api_name: 'province',
                operator: 'equals',
                condition: 'Canada',
              },
              {
                not: true,
                api_name: 'date_of_arrival_in_canada',
                operator: 'equals',
                condition: 'Canada',
              },
            ],
          },
          required: false,
          askOnRenewal: false,
          prefillOnRenewal: false,
          subQuestions: [
            {
              id: '72414',
              apiName: 'country_of_birth',
              displayName: 'Country of Birth',
              label: 'Country of Birth',
              helpText: null,
              component: 'countryDropdown',
              dataType: 'string',
              propsBlob: {},
              required: true,
              askOnRenewal: false,
              prefillOnRenewal: false,
              subQuestions: [],
              defaultValue: '',
            },
            {
              id: '72416',
              apiName: 'date_of_arrival_in_canada',
              displayName: 'Date of Arrival In Canada',
              label: 'Date of Arrival In Canada',
              helpText: null,
              component: 'calendar',
              dataType: 'string',
              propsBlob: {},
              required: true,
              askOnRenewal: false,
              prefillOnRenewal: false,
              subQuestions: [],
              defaultValue: '',
            },
            {
              id: '72417',
              apiName: 'province',
              displayName: 'Province',
              label: 'Province of Birth',
              helpText: null,
              component: 'InputToggle',
              dataType: 'string',
              propsBlob: {
                options: [
                  {
                    value: 'Alberta',
                    label: 'Alberta',
                  },
                  {
                    value: 'British Columbia',
                    label: 'British Columbia',
                  },
                  {
                    value: 'Manitoba',
                    label: 'Manitoba',
                  },
                  {
                    value: 'New Brunswick',
                    label: 'New Brunswick',
                  },
                  {
                    value: 'Newfoundland and Labrador',
                    label: 'Newfoundland and Labrador',
                  },
                  {
                    value: 'Northwest Territories',
                    label: 'Northwest Territories',
                  },
                  {
                    value: 'Nova Scotia',
                    label: 'Nova Scotia',
                  },
                  {
                    value: 'Nunavut',
                    label: 'Nunavut',
                  },
                  {
                    value: 'Ontario',
                    label: 'Ontario',
                  },
                  {
                    value: 'Prince Edward Island',
                    label: 'Prince Edward Island',
                  },
                  {
                    value: 'Quebec',
                    label: 'Quebec',
                  },
                  {
                    value: 'Saskatchewan',
                    label: 'Saskatchewan',
                  },
                  {
                    value: 'Yukon',
                    label: 'Yukon',
                  },
                ],
              },
              required: true,
              askOnRenewal: false,
              prefillOnRenewal: false,
              subQuestions: [],
              defaultValue: '',
            },
          ],
          defaultValue: '',
        },
        value: '1',
        subAnswers: [
          {
            questionInstance: {
              id: '72414',
              apiName: 'country_of_birth',
              displayName: 'Country of Birth',
              label: 'Country of Birth',
              helpText: null,
              component: 'countryDropdown',
              dataType: 'string',
              propsBlob: {},
              required: true,
              askOnRenewal: false,
              prefillOnRenewal: false,
              subQuestions: [],
              defaultValue: '',
            },
            value: 'Canada',
            subAnswers: [],
            details: {
              lat: null,
              lng: null,
              google: {},
              opta: {},
              openingHours: [],
              images: [],
            },
          },
          {
            questionInstance: {
              id: '72417',
              apiName: 'province',
              displayName: 'Province',
              label: 'Province of Birth',
              helpText: null,
              component: 'InputToggle',
              dataType: 'string',
              propsBlob: {
                options: [
                  {
                    value: 'Alberta',
                    label: 'Alberta',
                  },
                  {
                    value: 'British Columbia',
                    label: 'British Columbia',
                  },
                  {
                    value: 'Manitoba',
                    label: 'Manitoba',
                  },
                  {
                    value: 'New Brunswick',
                    label: 'New Brunswick',
                  },
                  {
                    value: 'Newfoundland and Labrador',
                    label: 'Newfoundland and Labrador',
                  },
                  {
                    value: 'Northwest Territories',
                    label: 'Northwest Territories',
                  },
                  {
                    value: 'Nova Scotia',
                    label: 'Nova Scotia',
                  },
                  {
                    value: 'Nunavut',
                    label: 'Nunavut',
                  },
                  {
                    value: 'Ontario',
                    label: 'Ontario',
                  },
                  {
                    value: 'Prince Edward Island',
                    label: 'Prince Edward Island',
                  },
                  {
                    value: 'Quebec',
                    label: 'Quebec',
                  },
                  {
                    value: 'Saskatchewan',
                    label: 'Saskatchewan',
                  },
                  {
                    value: 'Yukon',
                    label: 'Yukon',
                  },
                ],
              },
              required: true,
              askOnRenewal: false,
              prefillOnRenewal: false,
              subQuestions: [],
              defaultValue: '',
            },
            value: 'Alberta',
            subAnswers: [],
            details: {
              lat: null,
              lng: null,
              google: {},
              opta: {},
              openingHours: [],
              images: [],
            },
          },
        ],
        details: {
          lat: null,
          lng: null,
          google: {},
          opta: {},
          openingHours: [],
          images: [],
        },
      },
    ],
    details: {
      lat: null,
      lng: null,
      google: {},
      opta: {},
      openingHours: [],
      images: [],
    },
  },
  {
    questionInstance: {
      id: '72422',
      apiName: 'financial_information_and_occupation',
      displayName: 'Financial Information and Occupation',
      label: 'Financial Information and Occupation',
      helpText: null,
      component: 'repeatable',
      dataType: 'nested',
      propsBlob: {},
      required: false,
      askOnRenewal: false,
      prefillOnRenewal: false,
      subQuestions: [
        {
          id: '72424',
          apiName: 'occupation_and_duties',
          displayName: 'Occupation and Duties',
          label: 'Occupation and Duties',
          helpText: null,
          component: 'repeatable',
          dataType: 'nested',
          propsBlob: {},
          required: false,
          askOnRenewal: false,
          prefillOnRenewal: false,
          subQuestions: [
            {
              id: '72426',
              apiName: 'occupation_title',
              displayName: 'Occupation Title',
              label: 'Occupation Title',
              helpText: null,
              component: 'textfield',
              dataType: 'string',
              propsBlob: {},
              required: true,
              askOnRenewal: false,
              prefillOnRenewal: false,
              subQuestions: [],
              defaultValue: '',
            },
            {
              id: '72428',
              apiName: 'occupational_duties',
              displayName: 'Occupational Duties',
              label: 'Occupational Duties (Details of Occupation)',
              helpText: null,
              component: 'textarea',
              dataType: 'string',
              propsBlob: {},
              required: true,
              askOnRenewal: false,
              prefillOnRenewal: false,
              subQuestions: [],
              defaultValue: '',
            },
            {
              id: '72429',
              apiName: 'name_of_employer',
              displayName: 'Name of Employer',
              label: 'Name of Employer',
              helpText: null,
              component: 'textfield',
              dataType: 'string',
              propsBlob: {},
              required: true,
              askOnRenewal: false,
              prefillOnRenewal: false,
              subQuestions: [],
              defaultValue: '',
            },
          ],
          defaultValue: '',
        },
        {
          id: '72431',
          apiName: 'financial_information',
          displayName: 'Financial Information',
          label: 'Financial Information',
          helpText: null,
          component: 'repeatable',
          dataType: 'nested',
          propsBlob: {},
          required: false,
          askOnRenewal: false,
          prefillOnRenewal: false,
          subQuestions: [
            {
              id: '72434',
              apiName: 'annual_earned_income',
              displayName: 'Annual Earned Income',
              label: 'Annual Earned Income (in CAD)',
              helpText: null,
              component: 'numberinput',
              dataType: 'number',
              propsBlob: {
                dataType: '$',
              },
              required: true,
              askOnRenewal: false,
              prefillOnRenewal: false,
              subQuestions: [],
              defaultValue: '',
            },
            {
              id: '72436',
              apiName: 'other_sources_of_income_conditional',
              displayName: 'Other Sources of Income Conditional',
              label: 'Other Sources of Income Conditional',
              helpText: null,
              component: 'logic',
              dataType: 'nested',
              propsBlob: {
                operator: 'greater',
                condition: '0',
              },
              required: false,
              askOnRenewal: false,
              prefillOnRenewal: false,
              subQuestions: [
                {
                  id: '72437',
                  apiName: 'income_from_other_sources',
                  displayName: 'Income From Other Sources',
                  label: 'Income From Other Sources',
                  helpText: null,
                  component: 'numberinput',
                  dataType: 'number',
                  propsBlob: {
                    dataType: '$',
                  },
                  required: false,
                  askOnRenewal: false,
                  prefillOnRenewal: false,
                  subQuestions: [],
                  defaultValue: '',
                },
                {
                  id: '72440',
                  apiName: 'other_income_description',
                  displayName: 'Other Income Description',
                  label: 'Please describe the other income sources',
                  helpText: null,
                  component: 'textarea',
                  dataType: 'string',
                  propsBlob: {},
                  required: true,
                  askOnRenewal: false,
                  prefillOnRenewal: false,
                  subQuestions: [],
                  defaultValue: '',
                },
              ],
              defaultValue: '',
            },
            {
              id: '72443',
              apiName: 'canadian_net_worth',
              displayName: 'Canadian Net Worth',
              label: 'Canadian Net Worth',
              helpText: null,
              component: 'numberinput',
              dataType: 'number',
              propsBlob: {
                dataType: '$',
              },
              required: true,
              askOnRenewal: false,
              prefillOnRenewal: false,
              subQuestions: [],
              defaultValue: '',
            },
            {
              id: '72444',
              apiName: 'foreign_net_worth',
              displayName: 'Foreign Net Worth',
              label: 'Foreign Net Worth (if applicable)',
              helpText: null,
              component: 'numberinput',
              dataType: 'number',
              propsBlob: {
                dataType: '$',
              },
              required: false,
              askOnRenewal: false,
              prefillOnRenewal: false,
              subQuestions: [],
              defaultValue: '',
            },
          ],
          defaultValue: '',
        },
        {
          id: '72446',
          apiName: 'bankruptcy',
          displayName: 'Bankruptcy',
          label:
            'In the last five (5) years, have you declared personal or business bankruptcy or made a consumer proposal?',
          helpText: null,
          component: 'YesNoToggle',
          dataType: 'string',
          propsBlob: {
            options: [
              {
                value: 'yes',
                label: 'Yes',
              },
              {
                value: 'no',
                label: 'No',
              },
            ],
          },
          required: true,
          askOnRenewal: false,
          prefillOnRenewal: false,
          subQuestions: [],
          defaultValue: '',
        },
        {
          id: '72448',
          apiName: 'us_tax',
          displayName: 'us tax',
          label: 'Are you a US citizen or a US resident for US tax purposes?',
          helpText: null,
          component: 'YesNoToggle',
          dataType: 'string',
          propsBlob: {
            options: [
              {
                value: 'yes',
                label: 'Yes',
              },
              {
                value: 'no',
                label: 'No',
              },
            ],
          },
          required: true,
          askOnRenewal: false,
          prefillOnRenewal: false,
          subQuestions: [],
          defaultValue: '',
        },
        {
          id: '72450',
          apiName: 'tax_resident_outside_canada_and_us',
          displayName: 'tax resident outside canada and us',
          label:
            'Are you a tax resident in a jurisdiction other than Canada or the United States?',
          helpText: null,
          component: 'YesNoToggle',
          dataType: 'string',
          propsBlob: {
            options: [
              {
                value: 'yes',
                label: 'Yes',
              },
              {
                value: 'no',
                label: 'No',
              },
            ],
          },
          required: true,
          askOnRenewal: false,
          prefillOnRenewal: false,
          subQuestions: [],
          defaultValue: '',
        },
      ],
      defaultValue: '',
    },
    value: 1,
    subAnswers: [
      {
        questionInstance: {
          id: '72424',
          apiName: 'occupation_and_duties',
          displayName: 'Occupation and Duties',
          label: 'Occupation and Duties',
          helpText: null,
          component: 'repeatable',
          dataType: 'nested',
          propsBlob: {},
          required: false,
          askOnRenewal: false,
          prefillOnRenewal: false,
          subQuestions: [
            {
              id: '72426',
              apiName: 'occupation_title',
              displayName: 'Occupation Title',
              label: 'Occupation Title',
              helpText: null,
              component: 'textfield',
              dataType: 'string',
              propsBlob: {},
              required: true,
              askOnRenewal: false,
              prefillOnRenewal: false,
              subQuestions: [],
              defaultValue: '',
            },
            {
              id: '72428',
              apiName: 'occupational_duties',
              displayName: 'Occupational Duties',
              label: 'Occupational Duties (Details of Occupation)',
              helpText: null,
              component: 'textarea',
              dataType: 'string',
              propsBlob: {},
              required: true,
              askOnRenewal: false,
              prefillOnRenewal: false,
              subQuestions: [],
              defaultValue: '',
            },
            {
              id: '72429',
              apiName: 'name_of_employer',
              displayName: 'Name of Employer',
              label: 'Name of Employer',
              helpText: null,
              component: 'textfield',
              dataType: 'string',
              propsBlob: {},
              required: true,
              askOnRenewal: false,
              prefillOnRenewal: false,
              subQuestions: [],
              defaultValue: '',
            },
          ],
          defaultValue: '',
        },
        value: 1,
        subAnswers: [
          {
            questionInstance: {
              id: '72426',
              apiName: 'occupation_title',
              displayName: 'Occupation Title',
              label: 'Occupation Title',
              helpText: null,
              component: 'textfield',
              dataType: 'string',
              propsBlob: {},
              required: true,
              askOnRenewal: false,
              prefillOnRenewal: false,
              subQuestions: [],
              defaultValue: '',
            },
            value: 'Financial Analyst',
            subAnswers: [],
            details: {
              lat: null,
              lng: null,
              google: {},
              opta: {},
              openingHours: [],
              images: [],
            },
          },
          {
            questionInstance: {
              id: '72428',
              apiName: 'occupational_duties',
              displayName: 'Occupational Duties',
              label: 'Occupational Duties (Details of Occupation)',
              helpText: null,
              component: 'textarea',
              dataType: 'string',
              propsBlob: {},
              required: true,
              askOnRenewal: false,
              prefillOnRenewal: false,
              subQuestions: [],
              defaultValue: '',
            },
            value: 'Analyzing Financial Matters',
            subAnswers: [],
            details: {
              lat: null,
              lng: null,
              google: {},
              opta: {},
              openingHours: [],
              images: [],
            },
          },
          {
            questionInstance: {
              id: '72429',
              apiName: 'name_of_employer',
              displayName: 'Name of Employer',
              label: 'Name of Employer',
              helpText: null,
              component: 'textfield',
              dataType: 'string',
              propsBlob: {},
              required: true,
              askOnRenewal: false,
              prefillOnRenewal: false,
              subQuestions: [],
              defaultValue: '',
            },
            value: 'Finance Co.',
            subAnswers: [],
            details: {
              lat: null,
              lng: null,
              google: {},
              opta: {},
              openingHours: [],
              images: [],
            },
          },
        ],
        details: {
          lat: null,
          lng: null,
          google: {},
          opta: {},
          openingHours: [],
          images: [],
        },
      },
      {
        questionInstance: {
          id: '72431',
          apiName: 'financial_information',
          displayName: 'Financial Information',
          label: 'Financial Information',
          helpText: null,
          component: 'repeatable',
          dataType: 'nested',
          propsBlob: {},
          required: false,
          askOnRenewal: false,
          prefillOnRenewal: false,
          subQuestions: [
            {
              id: '72434',
              apiName: 'annual_earned_income',
              displayName: 'Annual Earned Income',
              label: 'Annual Earned Income (in CAD)',
              helpText: null,
              component: 'numberinput',
              dataType: 'number',
              propsBlob: {
                dataType: '$',
              },
              required: true,
              askOnRenewal: false,
              prefillOnRenewal: false,
              subQuestions: [],
              defaultValue: '',
            },
            {
              id: '72436',
              apiName: 'other_sources_of_income_conditional',
              displayName: 'Other Sources of Income Conditional',
              label: 'Other Sources of Income Conditional',
              helpText: null,
              component: 'logic',
              dataType: 'nested',
              propsBlob: {
                operator: 'greater',
                condition: '0',
              },
              required: false,
              askOnRenewal: false,
              prefillOnRenewal: false,
              subQuestions: [
                {
                  id: '72437',
                  apiName: 'income_from_other_sources',
                  displayName: 'Income From Other Sources',
                  label: 'Income From Other Sources',
                  helpText: null,
                  component: 'numberinput',
                  dataType: 'number',
                  propsBlob: {
                    dataType: '$',
                  },
                  required: false,
                  askOnRenewal: false,
                  prefillOnRenewal: false,
                  subQuestions: [],
                  defaultValue: '',
                },
                {
                  id: '72440',
                  apiName: 'other_income_description',
                  displayName: 'Other Income Description',
                  label: 'Please describe the other income sources',
                  helpText: null,
                  component: 'textarea',
                  dataType: 'string',
                  propsBlob: {},
                  required: true,
                  askOnRenewal: false,
                  prefillOnRenewal: false,
                  subQuestions: [],
                  defaultValue: '',
                },
              ],
              defaultValue: '',
            },
            {
              id: '72443',
              apiName: 'canadian_net_worth',
              displayName: 'Canadian Net Worth',
              label: 'Canadian Net Worth',
              helpText: null,
              component: 'numberinput',
              dataType: 'number',
              propsBlob: {
                dataType: '$',
              },
              required: true,
              askOnRenewal: false,
              prefillOnRenewal: false,
              subQuestions: [],
              defaultValue: '',
            },
            {
              id: '72444',
              apiName: 'foreign_net_worth',
              displayName: 'Foreign Net Worth',
              label: 'Foreign Net Worth (if applicable)',
              helpText: null,
              component: 'numberinput',
              dataType: 'number',
              propsBlob: {
                dataType: '$',
              },
              required: false,
              askOnRenewal: false,
              prefillOnRenewal: false,
              subQuestions: [],
              defaultValue: '',
            },
          ],
          defaultValue: '',
        },
        value: 1,
        subAnswers: [
          {
            questionInstance: {
              id: '72434',
              apiName: 'annual_earned_income',
              displayName: 'Annual Earned Income',
              label: 'Annual Earned Income (in CAD)',
              helpText: null,
              component: 'numberinput',
              dataType: 'number',
              propsBlob: {
                dataType: '$',
              },
              required: true,
              askOnRenewal: false,
              prefillOnRenewal: false,
              subQuestions: [],
              defaultValue: '',
            },
            value: '150000',
            subAnswers: [],
            details: {
              lat: null,
              lng: null,
              google: {},
              opta: {},
              openingHours: [],
              images: [],
            },
          },
          {
            questionInstance: {
              id: '72436',
              apiName: 'other_sources_of_income_conditional',
              displayName: 'Other Sources of Income Conditional',
              label: 'Other Sources of Income Conditional',
              helpText: null,
              component: 'logic',
              dataType: 'nested',
              propsBlob: {
                operator: 'greater',
                condition: '0',
              },
              required: false,
              askOnRenewal: false,
              prefillOnRenewal: false,
              subQuestions: [
                {
                  id: '72437',
                  apiName: 'income_from_other_sources',
                  displayName: 'Income From Other Sources',
                  label: 'Income From Other Sources',
                  helpText: null,
                  component: 'numberinput',
                  dataType: 'number',
                  propsBlob: {
                    dataType: '$',
                  },
                  required: false,
                  askOnRenewal: false,
                  prefillOnRenewal: false,
                  subQuestions: [],
                  defaultValue: '',
                },
                {
                  id: '72440',
                  apiName: 'other_income_description',
                  displayName: 'Other Income Description',
                  label: 'Please describe the other income sources',
                  helpText: null,
                  component: 'textarea',
                  dataType: 'string',
                  propsBlob: {},
                  required: true,
                  askOnRenewal: false,
                  prefillOnRenewal: false,
                  subQuestions: [],
                  defaultValue: '',
                },
              ],
              defaultValue: '',
            },
            value: '1',
            subAnswers: [
              {
                questionInstance: {
                  id: '72437',
                  apiName: 'income_from_other_sources',
                  displayName: 'Income From Other Sources',
                  label: 'Income From Other Sources',
                  helpText: null,
                  component: 'numberinput',
                  dataType: 'number',
                  propsBlob: {
                    dataType: '$',
                  },
                  required: false,
                  askOnRenewal: false,
                  prefillOnRenewal: false,
                  subQuestions: [],
                  defaultValue: '',
                },
                value: '20000',
                subAnswers: [],
                details: {
                  lat: null,
                  lng: null,
                  google: {},
                  opta: {},
                  openingHours: [],
                  images: [],
                },
              },
              {
                questionInstance: {
                  id: '72440',
                  apiName: 'other_income_description',
                  displayName: 'Other Income Description',
                  label: 'Please describe the other income sources',
                  helpText: null,
                  component: 'textarea',
                  dataType: 'string',
                  propsBlob: {},
                  required: true,
                  askOnRenewal: false,
                  prefillOnRenewal: false,
                  subQuestions: [],
                  defaultValue: '',
                },
                value: 'Rental Unit',
                subAnswers: [],
                details: {
                  lat: null,
                  lng: null,
                  google: {},
                  opta: {},
                  openingHours: [],
                  images: [],
                },
              },
            ],
            details: {
              lat: null,
              lng: null,
              google: {},
              opta: {},
              openingHours: [],
              images: [],
            },
          },
          {
            questionInstance: {
              id: '72443',
              apiName: 'canadian_net_worth',
              displayName: 'Canadian Net Worth',
              label: 'Canadian Net Worth',
              helpText: null,
              component: 'numberinput',
              dataType: 'number',
              propsBlob: {
                dataType: '$',
              },
              required: true,
              askOnRenewal: false,
              prefillOnRenewal: false,
              subQuestions: [],
              defaultValue: '',
            },
            value: '650000',
            subAnswers: [],
            details: {
              lat: null,
              lng: null,
              google: {},
              opta: {},
              openingHours: [],
              images: [],
            },
          },
          {
            questionInstance: {
              id: '72444',
              apiName: 'foreign_net_worth',
              displayName: 'Foreign Net Worth',
              label: 'Foreign Net Worth (if applicable)',
              helpText: null,
              component: 'numberinput',
              dataType: 'number',
              propsBlob: {
                dataType: '$',
              },
              required: false,
              askOnRenewal: false,
              prefillOnRenewal: false,
              subQuestions: [],
              defaultValue: '',
            },
            value: '0',
            subAnswers: [],
            details: {
              lat: null,
              lng: null,
              google: {},
              opta: {},
              openingHours: [],
              images: [],
            },
          },
        ],
        details: {
          lat: null,
          lng: null,
          google: {},
          opta: {},
          openingHours: [],
          images: [],
        },
      },
      {
        questionInstance: {
          id: '72446',
          apiName: 'bankruptcy',
          displayName: 'Bankruptcy',
          label:
            'In the last five (5) years, have you declared personal or business bankruptcy or made a consumer proposal?',
          helpText: null,
          component: 'YesNoToggle',
          dataType: 'string',
          propsBlob: {
            options: [
              {
                value: 'yes',
                label: 'Yes',
              },
              {
                value: 'no',
                label: 'No',
              },
            ],
          },
          required: true,
          askOnRenewal: false,
          prefillOnRenewal: false,
          subQuestions: [],
          defaultValue: '',
        },
        value: 'no',
        subAnswers: [],
        details: {
          lat: null,
          lng: null,
          google: {},
          opta: {},
          openingHours: [],
          images: [],
        },
      },
      {
        questionInstance: {
          id: '72448',
          apiName: 'us_tax',
          displayName: 'us tax',
          label: 'Are you a US citizen or a US resident for US tax purposes?',
          helpText: null,
          component: 'YesNoToggle',
          dataType: 'string',
          propsBlob: {
            options: [
              {
                value: 'yes',
                label: 'Yes',
              },
              {
                value: 'no',
                label: 'No',
              },
            ],
          },
          required: true,
          askOnRenewal: false,
          prefillOnRenewal: false,
          subQuestions: [],
          defaultValue: '',
        },
        value: 'no',
        subAnswers: [],
        details: {
          lat: null,
          lng: null,
          google: {},
          opta: {},
          openingHours: [],
          images: [],
        },
      },
      {
        questionInstance: {
          id: '72450',
          apiName: 'tax_resident_outside_canada_and_us',
          displayName: 'tax resident outside canada and us',
          label:
            'Are you a tax resident in a jurisdiction other than Canada or the United States?',
          helpText: null,
          component: 'YesNoToggle',
          dataType: 'string',
          propsBlob: {
            options: [
              {
                value: 'yes',
                label: 'Yes',
              },
              {
                value: 'no',
                label: 'No',
              },
            ],
          },
          required: true,
          askOnRenewal: false,
          prefillOnRenewal: false,
          subQuestions: [],
          defaultValue: '',
        },
        value: 'no',
        subAnswers: [],
        details: {
          lat: null,
          lng: null,
          google: {},
          opta: {},
          openingHours: [],
          images: [],
        },
      },
    ],
    details: {
      lat: null,
      lng: null,
      google: {},
      opta: {},
      openingHours: [],
      images: [],
    },
  },
  {
    questionInstance: {
      id: '72453',
      apiName: 'lifestyle_occupation',
      displayName: 'Lifestyle & Occupation',
      label: 'Lifestyle & Occupation',
      helpText: null,
      component: 'repeatable',
      dataType: 'nested',
      propsBlob: {},
      required: false,
      askOnRenewal: false,
      prefillOnRenewal: false,
      subQuestions: [
        {
          id: '72455',
          apiName: 'tobacco_use',
          displayName: 'Tobacco Use',
          label:
            'When was the last time you used tobacco in any form (including cigarettes, cigars, cigarillos, cannabis (marijuana) mixed with tobacco, electronic cigarettes, gum, patches, chewing tobacco or snuff, betel nuts, shisha, hookah / water pipe, etc.?',
          helpText: null,
          component: 'InputToggle',
          dataType: 'string',
          propsBlob: {
            options: [
              {
                value: 'Never',
                label: 'Never',
              },
              {
                value: 'In the past year',
                label: 'In the past year',
              },
              {
                value: 'Between 1 and 3 years ago',
                label: 'Between 1 and 3 years ago',
              },
              {
                value: 'Between 3 and 5 years ago',
                label: 'Between 3 and 5 years ago',
              },
              {
                value: 'More than 5 years ago',
                label: 'More than 5 years ago',
              },
            ],
          },
          required: true,
          askOnRenewal: false,
          prefillOnRenewal: false,
          subQuestions: [],
          defaultValue: '',
        },
        {
          id: '72457',
          apiName: 'cannabis_use',
          displayName: 'Cannabis Use',
          label:
            'Do you consume cannabis products for recreational or medicinal purposes?',
          helpText: null,
          component: 'YesNoToggle',
          dataType: 'string',
          propsBlob: {
            options: [
              {
                value: 'yes',
                label: 'Yes',
              },
              {
                value: 'no',
                label: 'No',
              },
            ],
          },
          required: true,
          askOnRenewal: false,
          prefillOnRenewal: false,
          subQuestions: [],
          defaultValue: '',
        },
        {
          id: '72459',
          apiName: 'other_drug_use',
          displayName: 'Other Drug Use',
          label:
            'In the last ten (10) years have you used drugs or narcotics that were not prescribed by a physician (e.g., cocaine, ecstasy, LSD, magic mushrooms, heroin, fentanyl, anabolic steroids, etc.)?',
          helpText: null,
          component: 'YesNoToggle',
          dataType: 'string',
          propsBlob: {
            options: [
              {
                value: 'yes',
                label: 'Yes',
              },
              {
                value: 'no',
                label: 'No',
              },
            ],
          },
          required: true,
          askOnRenewal: false,
          prefillOnRenewal: false,
          subQuestions: [],
          defaultValue: '',
        },
        {
          id: '72460',
          apiName: 'driving_convictions',
          displayName: 'Driving Convictions',
          label:
            'In the last three (3) years, have you been found guilty of two (2) or more violations of the Highway Safety Code?',
          helpText: null,
          component: 'YesNoToggle',
          dataType: 'string',
          propsBlob: {
            options: [
              {
                value: 'yes',
                label: 'Yes',
              },
              {
                value: 'no',
                label: 'No',
              },
            ],
          },
          required: true,
          askOnRenewal: false,
          prefillOnRenewal: false,
          subQuestions: [],
          defaultValue: '',
        },
        {
          id: '72461',
          apiName: 'high_risk_activities',
          displayName: 'High Risk Activities',
          label:
            'In the last twelve (12) months, have you participated in activities such as motorized vehicle races, scuba diving, skydiving, flying ultralights, hang gliding, mountaineering or rock climbing, bungee jumping, off-trail skiing (heliskiing, catskiing, etc.), combat sports or any other hazardous sport or do you intend to do so in the next twelve (12) months?',
          helpText: null,
          component: 'YesNoToggle',
          dataType: 'string',
          propsBlob: {
            options: [
              {
                value: 'yes',
                label: 'Yes',
              },
              {
                value: 'no',
                label: 'No',
              },
            ],
          },
          required: true,
          askOnRenewal: false,
          prefillOnRenewal: false,
          subQuestions: [],
          defaultValue: '',
        },
        {
          id: '72462',
          apiName: 'piloting_activities',
          displayName: 'Piloting Activities',
          label:
            'Have you within the past 5 years flown as a pilot, student pilot, or crew member, or do you intend to do so?',
          helpText: null,
          component: 'YesNoToggle',
          dataType: 'string',
          propsBlob: {
            options: [
              {
                value: 'yes',
                label: 'Yes',
              },
              {
                value: 'no',
                label: 'No',
              },
            ],
          },
          required: true,
          askOnRenewal: false,
          prefillOnRenewal: false,
          subQuestions: [],
          defaultValue: '',
        },
      ],
      defaultValue: '',
    },
    value: 1,
    subAnswers: [
      {
        questionInstance: {
          id: '72455',
          apiName: 'tobacco_use',
          displayName: 'Tobacco Use',
          label:
            'When was the last time you used tobacco in any form (including cigarettes, cigars, cigarillos, cannabis (marijuana) mixed with tobacco, electronic cigarettes, gum, patches, chewing tobacco or snuff, betel nuts, shisha, hookah / water pipe, etc.?',
          helpText: null,
          component: 'InputToggle',
          dataType: 'string',
          propsBlob: {
            options: [
              {
                value: 'Never',
                label: 'Never',
              },
              {
                value: 'In the past year',
                label: 'In the past year',
              },
              {
                value: 'Between 1 and 3 years ago',
                label: 'Between 1 and 3 years ago',
              },
              {
                value: 'Between 3 and 5 years ago',
                label: 'Between 3 and 5 years ago',
              },
              {
                value: 'More than 5 years ago',
                label: 'More than 5 years ago',
              },
            ],
          },
          required: true,
          askOnRenewal: false,
          prefillOnRenewal: false,
          subQuestions: [],
          defaultValue: '',
        },
        value: 'Never',
        subAnswers: [],
        details: {
          lat: null,
          lng: null,
          google: {},
          opta: {},
          openingHours: [],
          images: [],
        },
      },
      {
        questionInstance: {
          id: '72457',
          apiName: 'cannabis_use',
          displayName: 'Cannabis Use',
          label:
            'Do you consume cannabis products for recreational or medicinal purposes?',
          helpText: null,
          component: 'YesNoToggle',
          dataType: 'string',
          propsBlob: {
            options: [
              {
                value: 'yes',
                label: 'Yes',
              },
              {
                value: 'no',
                label: 'No',
              },
            ],
          },
          required: true,
          askOnRenewal: false,
          prefillOnRenewal: false,
          subQuestions: [],
          defaultValue: '',
        },
        value: 'no',
        subAnswers: [],
        details: {
          lat: null,
          lng: null,
          google: {},
          opta: {},
          openingHours: [],
          images: [],
        },
      },
      {
        questionInstance: {
          id: '72459',
          apiName: 'other_drug_use',
          displayName: 'Other Drug Use',
          label:
            'In the last ten (10) years have you used drugs or narcotics that were not prescribed by a physician (e.g., cocaine, ecstasy, LSD, magic mushrooms, heroin, fentanyl, anabolic steroids, etc.)?',
          helpText: null,
          component: 'YesNoToggle',
          dataType: 'string',
          propsBlob: {
            options: [
              {
                value: 'yes',
                label: 'Yes',
              },
              {
                value: 'no',
                label: 'No',
              },
            ],
          },
          required: true,
          askOnRenewal: false,
          prefillOnRenewal: false,
          subQuestions: [],
          defaultValue: '',
        },
        value: 'no',
        subAnswers: [],
        details: {
          lat: null,
          lng: null,
          google: {},
          opta: {},
          openingHours: [],
          images: [],
        },
      },
      {
        questionInstance: {
          id: '72460',
          apiName: 'driving_convictions',
          displayName: 'Driving Convictions',
          label:
            'In the last three (3) years, have you been found guilty of two (2) or more violations of the Highway Safety Code?',
          helpText: null,
          component: 'YesNoToggle',
          dataType: 'string',
          propsBlob: {
            options: [
              {
                value: 'yes',
                label: 'Yes',
              },
              {
                value: 'no',
                label: 'No',
              },
            ],
          },
          required: true,
          askOnRenewal: false,
          prefillOnRenewal: false,
          subQuestions: [],
          defaultValue: '',
        },
        value: 'no',
        subAnswers: [],
        details: {
          lat: null,
          lng: null,
          google: {},
          opta: {},
          openingHours: [],
          images: [],
        },
      },
      {
        questionInstance: {
          id: '72461',
          apiName: 'high_risk_activities',
          displayName: 'High Risk Activities',
          label:
            'In the last twelve (12) months, have you participated in activities such as motorized vehicle races, scuba diving, skydiving, flying ultralights, hang gliding, mountaineering or rock climbing, bungee jumping, off-trail skiing (heliskiing, catskiing, etc.), combat sports or any other hazardous sport or do you intend to do so in the next twelve (12) months?',
          helpText: null,
          component: 'YesNoToggle',
          dataType: 'string',
          propsBlob: {
            options: [
              {
                value: 'yes',
                label: 'Yes',
              },
              {
                value: 'no',
                label: 'No',
              },
            ],
          },
          required: true,
          askOnRenewal: false,
          prefillOnRenewal: false,
          subQuestions: [],
          defaultValue: '',
        },
        value: 'no',
        subAnswers: [],
        details: {
          lat: null,
          lng: null,
          google: {},
          opta: {},
          openingHours: [],
          images: [],
        },
      },
      {
        questionInstance: {
          id: '72462',
          apiName: 'piloting_activities',
          displayName: 'Piloting Activities',
          label:
            'Have you within the past 5 years flown as a pilot, student pilot, or crew member, or do you intend to do so?',
          helpText: null,
          component: 'YesNoToggle',
          dataType: 'string',
          propsBlob: {
            options: [
              {
                value: 'yes',
                label: 'Yes',
              },
              {
                value: 'no',
                label: 'No',
              },
            ],
          },
          required: true,
          askOnRenewal: false,
          prefillOnRenewal: false,
          subQuestions: [],
          defaultValue: '',
        },
        value: 'no',
        subAnswers: [],
        details: {
          lat: null,
          lng: null,
          google: {},
          opta: {},
          openingHours: [],
          images: [],
        },
      },
    ],
    details: {
      lat: null,
      lng: null,
      google: {},
      opta: {},
      openingHours: [],
      images: [],
    },
  },
  {
    questionInstance: {
      id: '72463',
      apiName: 'medical_questions',
      displayName: 'Medical Questions',
      label: 'Medical Questions',
      helpText: null,
      component: 'repeatable',
      dataType: 'nested',
      propsBlob: {},
      required: false,
      askOnRenewal: false,
      prefillOnRenewal: false,
      subQuestions: [
        {
          id: '72464',
          apiName: 'height_feet_',
          displayName: 'Height (feet)',
          label: 'Height (feet)',
          helpText: null,
          component: 'numberinput',
          dataType: 'number',
          propsBlob: {
            dataType: 'ft',
          },
          required: true,
          askOnRenewal: false,
          prefillOnRenewal: false,
          subQuestions: [],
          defaultValue: '',
        },
        {
          id: '72465',
          apiName: 'height_inches_',
          displayName: 'Height (inches)',
          label: 'Height (inches)',
          helpText: null,
          component: 'numberinput',
          dataType: 'number',
          propsBlob: {
            dataType: 'in',
          },
          required: true,
          askOnRenewal: false,
          prefillOnRenewal: false,
          subQuestions: [],
          defaultValue: '',
        },
        {
          id: '72466',
          apiName: 'weight',
          displayName: 'Weight',
          label: 'Weight',
          helpText: null,
          component: 'numberinput',
          dataType: 'number',
          propsBlob: {
            dataType: 'lb',
          },
          required: true,
          askOnRenewal: false,
          prefillOnRenewal: false,
          subQuestions: [],
          defaultValue: '',
        },
        {
          id: '72467',
          apiName: 'physician_conditional',
          displayName: 'Physician Conditional',
          label: 'Physician Conditional',
          helpText: null,
          component: 'logic',
          dataType: 'nested',
          propsBlob: {
            operator: 'equals',
            condition: 'yes',
          },
          required: false,
          askOnRenewal: false,
          prefillOnRenewal: false,
          subQuestions: [
            {
              id: '72468',
              apiName: 'physician_boolean',
              displayName: 'Physician Boolean',
              label: 'Do you have a physician?',
              helpText: null,
              component: 'YesNoToggle',
              dataType: 'string',
              propsBlob: {
                options: [
                  {
                    value: 'yes',
                    label: 'Yes',
                  },
                  {
                    value: 'no',
                    label: 'No',
                  },
                ],
              },
              required: true,
              askOnRenewal: false,
              prefillOnRenewal: false,
              subQuestions: [],
              defaultValue: '',
            },
            {
              id: '72469',
              apiName: 'physician_name',
              displayName: 'Physician Name',
              label: 'Name',
              helpText: null,
              component: 'textfield',
              dataType: 'string',
              propsBlob: {},
              required: true,
              askOnRenewal: false,
              prefillOnRenewal: false,
              subQuestions: [],
              defaultValue: '',
            },
            {
              id: '72470',
              apiName: 'physician_address',
              displayName: 'Physician Address',
              label: 'Address',
              helpText: null,
              component: 'location',
              dataType: 'nested',
              propsBlob: {},
              required: false,
              askOnRenewal: false,
              prefillOnRenewal: false,
              subQuestions: [
                {
                  id: '72471',
                  apiName: 'address',
                  displayName: 'address',
                  label: 'Address',
                  helpText: null,
                  component: 'textfield',
                  dataType: 'string',
                  propsBlob: {},
                  required: true,
                  askOnRenewal: false,
                  prefillOnRenewal: false,
                  subQuestions: [],
                  defaultValue: '',
                },
                {
                  id: '72472',
                  apiName: 'city',
                  displayName: 'city',
                  label: 'City',
                  helpText: null,
                  component: 'textfield',
                  dataType: 'string',
                  propsBlob: {},
                  required: true,
                  askOnRenewal: false,
                  prefillOnRenewal: false,
                  subQuestions: [],
                  defaultValue: '',
                },
                {
                  id: '72473',
                  apiName: 'province',
                  displayName: 'province',
                  label: 'Province',
                  helpText: null,
                  component: 'textfield',
                  dataType: 'string',
                  propsBlob: {},
                  required: true,
                  askOnRenewal: false,
                  prefillOnRenewal: false,
                  subQuestions: [],
                  defaultValue: '',
                },
                {
                  id: '72474',
                  apiName: 'postal',
                  displayName: 'postal',
                  label: 'Postal Code',
                  helpText: null,
                  component: 'textfield',
                  dataType: 'string',
                  propsBlob: {},
                  required: true,
                  askOnRenewal: false,
                  prefillOnRenewal: false,
                  subQuestions: [],
                  defaultValue: '',
                },
              ],
              defaultValue: '',
            },
            {
              id: '72475',
              apiName: 'recent_medical_events',
              displayName: 'Recent Medical Events',
              label: 'Have you within the past year',
              helpText: null,
              component: 'repeatable',
              dataType: 'nested',
              propsBlob: {},
              required: false,
              askOnRenewal: false,
              prefillOnRenewal: false,
              subQuestions: [
                {
                  id: '72476',
                  apiName: 'hospital_admittance',
                  displayName: 'Hospital Admittance',
                  label: 'Been admitted to a hospital',
                  helpText: null,
                  component: 'checkbox',
                  dataType: 'boolean',
                  propsBlob: {},
                  required: false,
                  askOnRenewal: false,
                  prefillOnRenewal: false,
                  subQuestions: [],
                  defaultValue: '',
                },
                {
                  id: '72477',
                  apiName: 'test_advisory',
                  displayName: 'Test Advisory',
                  label:
                    'Been advised to have any tests, investigations, or surgery?',
                  helpText: null,
                  component: 'checkbox',
                  dataType: 'boolean',
                  propsBlob: {},
                  required: false,
                  askOnRenewal: false,
                  prefillOnRenewal: false,
                  subQuestions: [],
                  defaultValue: '',
                },
                {
                  id: '72478',
                  apiName: 'other_symptoms',
                  displayName: 'Other Symptoms',
                  label:
                    "Experienced symptoms for which you haven't sought treatment",
                  helpText: null,
                  component: 'checkbox',
                  dataType: 'boolean',
                  propsBlob: {},
                  required: false,
                  askOnRenewal: false,
                  prefillOnRenewal: false,
                  subQuestions: [],
                  defaultValue: '',
                },
              ],
              defaultValue: '',
            },
          ],
          defaultValue: '',
        },
        {
          id: '72479',
          apiName: 'health_history',
          displayName: 'Health History',
          label: 'Have you  ever been treated for or had any indication of',
          helpText: null,
          component: 'repeatable',
          dataType: 'nested',
          propsBlob: {},
          required: false,
          askOnRenewal: false,
          prefillOnRenewal: false,
          subQuestions: [
            {
              id: '72480',
              apiName: 'heart_or_circulatory_disease',
              displayName: 'Heart or circulatory disease',
              label: 'Heart or circulatory disease',
              helpText: null,
              component: 'checkbox',
              dataType: 'boolean',
              propsBlob: {},
              required: false,
              askOnRenewal: false,
              prefillOnRenewal: false,
              subQuestions: [],
              defaultValue: '',
            },
            {
              id: '72481',
              apiName: 'high_blood_pressure',
              displayName: 'High blood pressure',
              label: 'High blood pressure',
              helpText: null,
              component: 'checkbox',
              dataType: 'boolean',
              propsBlob: {},
              required: false,
              askOnRenewal: false,
              prefillOnRenewal: false,
              subQuestions: [],
              defaultValue: '',
            },
            {
              id: '72482',
              apiName: 'cancer_or_tumor',
              displayName: 'Cancer or tumor',
              label: 'Cancer or tumor',
              helpText: null,
              component: 'checkbox',
              dataType: 'boolean',
              propsBlob: {},
              required: false,
              askOnRenewal: false,
              prefillOnRenewal: false,
              subQuestions: [],
              defaultValue: '',
            },
            {
              id: '72483',
              apiName: 'diabetes',
              displayName: 'Diabetes',
              label: 'Diabetes',
              helpText: null,
              component: 'checkbox',
              dataType: 'boolean',
              propsBlob: {},
              required: false,
              askOnRenewal: false,
              prefillOnRenewal: false,
              subQuestions: [],
              defaultValue: '',
            },
            {
              id: '72484',
              apiName: 'hiv_aids',
              displayName: 'HIV / AIDS',
              label: 'HIV / AIDS',
              helpText: null,
              component: 'checkbox',
              dataType: 'boolean',
              propsBlob: {},
              required: false,
              askOnRenewal: false,
              prefillOnRenewal: false,
              subQuestions: [],
              defaultValue: '',
            },
            {
              id: '72485',
              apiName: 'other_major_illness_conditional',
              displayName: 'Other Major Illness Conditional',
              label: 'Other Major Illness Conditional',
              helpText: null,
              component: 'logic',
              dataType: 'nested',
              propsBlob: {
                operator: 'equals',
                condition: 'true',
              },
              required: false,
              askOnRenewal: false,
              prefillOnRenewal: false,
              subQuestions: [
                {
                  id: '72486',
                  apiName: 'other_major_illnesses',
                  displayName: 'Other major illnesses',
                  label: 'Other major illnesses',
                  helpText: null,
                  component: 'checkbox',
                  dataType: 'boolean',
                  propsBlob: {},
                  required: false,
                  askOnRenewal: false,
                  prefillOnRenewal: false,
                  subQuestions: [],
                  defaultValue: '',
                },
                {
                  id: '72487',
                  apiName: 'list_illness',
                  displayName: 'List Illness',
                  label: 'List Illness',
                  helpText: null,
                  component: 'textfield',
                  dataType: 'string',
                  propsBlob: {},
                  required: true,
                  askOnRenewal: false,
                  prefillOnRenewal: false,
                  subQuestions: [],
                  defaultValue: '',
                },
              ],
              defaultValue: '',
            },
          ],
          defaultValue: '',
        },
      ],
      defaultValue: '',
    },
    value: 1,
    subAnswers: [
      {
        questionInstance: {
          id: '72464',
          apiName: 'height_feet_',
          displayName: 'Height (feet)',
          label: 'Height (feet)',
          helpText: null,
          component: 'numberinput',
          dataType: 'number',
          propsBlob: {
            dataType: 'ft',
          },
          required: true,
          askOnRenewal: false,
          prefillOnRenewal: false,
          subQuestions: [],
          defaultValue: '',
        },
        value: '5',
        subAnswers: [],
        details: {
          lat: null,
          lng: null,
          google: {},
          opta: {},
          openingHours: [],
          images: [],
        },
      },
      {
        questionInstance: {
          id: '72465',
          apiName: 'height_inches_',
          displayName: 'Height (inches)',
          label: 'Height (inches)',
          helpText: null,
          component: 'numberinput',
          dataType: 'number',
          propsBlob: {
            dataType: 'in',
          },
          required: true,
          askOnRenewal: false,
          prefillOnRenewal: false,
          subQuestions: [],
          defaultValue: '',
        },
        value: '10',
        subAnswers: [],
        details: {
          lat: null,
          lng: null,
          google: {},
          opta: {},
          openingHours: [],
          images: [],
        },
      },
      {
        questionInstance: {
          id: '72466',
          apiName: 'weight',
          displayName: 'Weight',
          label: 'Weight',
          helpText: null,
          component: 'numberinput',
          dataType: 'number',
          propsBlob: {
            dataType: 'lb',
          },
          required: true,
          askOnRenewal: false,
          prefillOnRenewal: false,
          subQuestions: [],
          defaultValue: '',
        },
        value: '170',
        subAnswers: [],
        details: {
          lat: null,
          lng: null,
          google: {},
          opta: {},
          openingHours: [],
          images: [],
        },
      },
      {
        questionInstance: {
          id: '72467',
          apiName: 'physician_conditional',
          displayName: 'Physician Conditional',
          label: 'Physician Conditional',
          helpText: null,
          component: 'logic',
          dataType: 'nested',
          propsBlob: {
            operator: 'equals',
            condition: 'yes',
          },
          required: false,
          askOnRenewal: false,
          prefillOnRenewal: false,
          subQuestions: [
            {
              id: '72468',
              apiName: 'physician_boolean',
              displayName: 'Physician Boolean',
              label: 'Do you have a physician?',
              helpText: null,
              component: 'YesNoToggle',
              dataType: 'string',
              propsBlob: {
                options: [
                  {
                    value: 'yes',
                    label: 'Yes',
                  },
                  {
                    value: 'no',
                    label: 'No',
                  },
                ],
              },
              required: true,
              askOnRenewal: false,
              prefillOnRenewal: false,
              subQuestions: [],
              defaultValue: '',
            },
            {
              id: '72469',
              apiName: 'physician_name',
              displayName: 'Physician Name',
              label: 'Name',
              helpText: null,
              component: 'textfield',
              dataType: 'string',
              propsBlob: {},
              required: true,
              askOnRenewal: false,
              prefillOnRenewal: false,
              subQuestions: [],
              defaultValue: '',
            },
            {
              id: '72470',
              apiName: 'physician_address',
              displayName: 'Physician Address',
              label: 'Address',
              helpText: null,
              component: 'location',
              dataType: 'nested',
              propsBlob: {},
              required: false,
              askOnRenewal: false,
              prefillOnRenewal: false,
              subQuestions: [
                {
                  id: '72471',
                  apiName: 'address',
                  displayName: 'address',
                  label: 'Address',
                  helpText: null,
                  component: 'textfield',
                  dataType: 'string',
                  propsBlob: {},
                  required: true,
                  askOnRenewal: false,
                  prefillOnRenewal: false,
                  subQuestions: [],
                  defaultValue: '',
                },
                {
                  id: '72472',
                  apiName: 'city',
                  displayName: 'city',
                  label: 'City',
                  helpText: null,
                  component: 'textfield',
                  dataType: 'string',
                  propsBlob: {},
                  required: true,
                  askOnRenewal: false,
                  prefillOnRenewal: false,
                  subQuestions: [],
                  defaultValue: '',
                },
                {
                  id: '72473',
                  apiName: 'province',
                  displayName: 'province',
                  label: 'Province',
                  helpText: null,
                  component: 'textfield',
                  dataType: 'string',
                  propsBlob: {},
                  required: true,
                  askOnRenewal: false,
                  prefillOnRenewal: false,
                  subQuestions: [],
                  defaultValue: '',
                },
                {
                  id: '72474',
                  apiName: 'postal',
                  displayName: 'postal',
                  label: 'Postal Code',
                  helpText: null,
                  component: 'textfield',
                  dataType: 'string',
                  propsBlob: {},
                  required: true,
                  askOnRenewal: false,
                  prefillOnRenewal: false,
                  subQuestions: [],
                  defaultValue: '',
                },
              ],
              defaultValue: '',
            },
            {
              id: '72475',
              apiName: 'recent_medical_events',
              displayName: 'Recent Medical Events',
              label: 'Have you within the past year',
              helpText: null,
              component: 'repeatable',
              dataType: 'nested',
              propsBlob: {},
              required: false,
              askOnRenewal: false,
              prefillOnRenewal: false,
              subQuestions: [
                {
                  id: '72476',
                  apiName: 'hospital_admittance',
                  displayName: 'Hospital Admittance',
                  label: 'Been admitted to a hospital',
                  helpText: null,
                  component: 'checkbox',
                  dataType: 'boolean',
                  propsBlob: {},
                  required: false,
                  askOnRenewal: false,
                  prefillOnRenewal: false,
                  subQuestions: [],
                  defaultValue: '',
                },
                {
                  id: '72477',
                  apiName: 'test_advisory',
                  displayName: 'Test Advisory',
                  label:
                    'Been advised to have any tests, investigations, or surgery?',
                  helpText: null,
                  component: 'checkbox',
                  dataType: 'boolean',
                  propsBlob: {},
                  required: false,
                  askOnRenewal: false,
                  prefillOnRenewal: false,
                  subQuestions: [],
                  defaultValue: '',
                },
                {
                  id: '72478',
                  apiName: 'other_symptoms',
                  displayName: 'Other Symptoms',
                  label:
                    "Experienced symptoms for which you haven't sought treatment",
                  helpText: null,
                  component: 'checkbox',
                  dataType: 'boolean',
                  propsBlob: {},
                  required: false,
                  askOnRenewal: false,
                  prefillOnRenewal: false,
                  subQuestions: [],
                  defaultValue: '',
                },
              ],
              defaultValue: '',
            },
          ],
          defaultValue: '',
        },
        value: '1',
        subAnswers: [
          {
            questionInstance: {
              id: '72468',
              apiName: 'physician_boolean',
              displayName: 'Physician Boolean',
              label: 'Do you have a physician?',
              helpText: null,
              component: 'YesNoToggle',
              dataType: 'string',
              propsBlob: {
                options: [
                  {
                    value: 'yes',
                    label: 'Yes',
                  },
                  {
                    value: 'no',
                    label: 'No',
                  },
                ],
              },
              required: true,
              askOnRenewal: false,
              prefillOnRenewal: false,
              subQuestions: [],
              defaultValue: '',
            },
            value: 'yes',
            subAnswers: [],
            details: {
              lat: null,
              lng: null,
              google: {},
              opta: {},
              openingHours: [],
              images: [],
            },
          },
          {
            questionInstance: {
              id: '72469',
              apiName: 'physician_name',
              displayName: 'Physician Name',
              label: 'Name',
              helpText: null,
              component: 'textfield',
              dataType: 'string',
              propsBlob: {},
              required: true,
              askOnRenewal: false,
              prefillOnRenewal: false,
              subQuestions: [],
              defaultValue: '',
            },
            value: 'Dr. Warren',
            subAnswers: [],
            details: {
              lat: null,
              lng: null,
              google: {},
              opta: {},
              openingHours: [],
              images: [],
            },
          },
          {
            questionInstance: {
              id: '72470',
              apiName: 'physician_address',
              displayName: 'Physician Address',
              label: 'Address',
              helpText: null,
              component: 'location',
              dataType: 'nested',
              propsBlob: {},
              required: false,
              askOnRenewal: false,
              prefillOnRenewal: false,
              subQuestions: [
                {
                  id: '72471',
                  apiName: 'address',
                  displayName: 'address',
                  label: 'Address',
                  helpText: null,
                  component: 'textfield',
                  dataType: 'string',
                  propsBlob: {},
                  required: true,
                  askOnRenewal: false,
                  prefillOnRenewal: false,
                  subQuestions: [],
                  defaultValue: '',
                },
                {
                  id: '72472',
                  apiName: 'city',
                  displayName: 'city',
                  label: 'City',
                  helpText: null,
                  component: 'textfield',
                  dataType: 'string',
                  propsBlob: {},
                  required: true,
                  askOnRenewal: false,
                  prefillOnRenewal: false,
                  subQuestions: [],
                  defaultValue: '',
                },
                {
                  id: '72473',
                  apiName: 'province',
                  displayName: 'province',
                  label: 'Province',
                  helpText: null,
                  component: 'textfield',
                  dataType: 'string',
                  propsBlob: {},
                  required: true,
                  askOnRenewal: false,
                  prefillOnRenewal: false,
                  subQuestions: [],
                  defaultValue: '',
                },
                {
                  id: '72474',
                  apiName: 'postal',
                  displayName: 'postal',
                  label: 'Postal Code',
                  helpText: null,
                  component: 'textfield',
                  dataType: 'string',
                  propsBlob: {},
                  required: true,
                  askOnRenewal: false,
                  prefillOnRenewal: false,
                  subQuestions: [],
                  defaultValue: '',
                },
              ],
              defaultValue: '',
            },
            value: '1',
            subAnswers: [
              {
                questionInstance: {
                  id: '72471',
                  apiName: 'address',
                  displayName: 'address',
                  label: 'Address',
                  helpText: null,
                  component: 'textfield',
                  dataType: 'string',
                  propsBlob: {},
                  required: true,
                  askOnRenewal: false,
                  prefillOnRenewal: false,
                  subQuestions: [],
                  defaultValue: '',
                },
                value: '221 Medical St.',
                subAnswers: [],
                details: {
                  lat: null,
                  lng: null,
                  google: {},
                  opta: {},
                  openingHours: [],
                  images: [],
                },
              },
              {
                questionInstance: {
                  id: '72472',
                  apiName: 'city',
                  displayName: 'city',
                  label: 'City',
                  helpText: null,
                  component: 'textfield',
                  dataType: 'string',
                  propsBlob: {},
                  required: true,
                  askOnRenewal: false,
                  prefillOnRenewal: false,
                  subQuestions: [],
                  defaultValue: '',
                },
                value: 'Vancouver',
                subAnswers: [],
                details: {
                  lat: null,
                  lng: null,
                  google: {},
                  opta: {},
                  openingHours: [],
                  images: [],
                },
              },
              {
                questionInstance: {
                  id: '72473',
                  apiName: 'province',
                  displayName: 'province',
                  label: 'Province',
                  helpText: null,
                  component: 'textfield',
                  dataType: 'string',
                  propsBlob: {},
                  required: true,
                  askOnRenewal: false,
                  prefillOnRenewal: false,
                  subQuestions: [],
                  defaultValue: '',
                },
                value: 'BC',
                subAnswers: [],
                details: {
                  lat: null,
                  lng: null,
                  google: {},
                  opta: {},
                  openingHours: [],
                  images: [],
                },
              },
              {
                questionInstance: {
                  id: '72474',
                  apiName: 'postal',
                  displayName: 'postal',
                  label: 'Postal Code',
                  helpText: null,
                  component: 'textfield',
                  dataType: 'string',
                  propsBlob: {},
                  required: true,
                  askOnRenewal: false,
                  prefillOnRenewal: false,
                  subQuestions: [],
                  defaultValue: '',
                },
                value: 'T3H 6A4',
                subAnswers: [],
                details: {
                  lat: null,
                  lng: null,
                  google: {},
                  opta: {},
                  openingHours: [],
                  images: [],
                },
              },
            ],
            details: {
              lat: null,
              lng: null,
              google: {},
              opta: {},
              openingHours: [],
              images: [],
            },
          },
          {
            questionInstance: {
              id: '72475',
              apiName: 'recent_medical_events',
              displayName: 'Recent Medical Events',
              label: 'Have you within the past year',
              helpText: null,
              component: 'repeatable',
              dataType: 'nested',
              propsBlob: {},
              required: false,
              askOnRenewal: false,
              prefillOnRenewal: false,
              subQuestions: [
                {
                  id: '72476',
                  apiName: 'hospital_admittance',
                  displayName: 'Hospital Admittance',
                  label: 'Been admitted to a hospital',
                  helpText: null,
                  component: 'checkbox',
                  dataType: 'boolean',
                  propsBlob: {},
                  required: false,
                  askOnRenewal: false,
                  prefillOnRenewal: false,
                  subQuestions: [],
                  defaultValue: '',
                },
                {
                  id: '72477',
                  apiName: 'test_advisory',
                  displayName: 'Test Advisory',
                  label:
                    'Been advised to have any tests, investigations, or surgery?',
                  helpText: null,
                  component: 'checkbox',
                  dataType: 'boolean',
                  propsBlob: {},
                  required: false,
                  askOnRenewal: false,
                  prefillOnRenewal: false,
                  subQuestions: [],
                  defaultValue: '',
                },
                {
                  id: '72478',
                  apiName: 'other_symptoms',
                  displayName: 'Other Symptoms',
                  label:
                    "Experienced symptoms for which you haven't sought treatment",
                  helpText: null,
                  component: 'checkbox',
                  dataType: 'boolean',
                  propsBlob: {},
                  required: false,
                  askOnRenewal: false,
                  prefillOnRenewal: false,
                  subQuestions: [],
                  defaultValue: '',
                },
              ],
              defaultValue: '',
            },
            value: 1,
            subAnswers: [
              {
                questionInstance: {
                  id: '72476',
                  apiName: 'hospital_admittance',
                  displayName: 'Hospital Admittance',
                  label: 'Been admitted to a hospital',
                  helpText: null,
                  component: 'checkbox',
                  dataType: 'boolean',
                  propsBlob: {},
                  required: false,
                  askOnRenewal: false,
                  prefillOnRenewal: false,
                  subQuestions: [],
                  defaultValue: '',
                },
                value: false,
                subAnswers: [],
                details: {
                  lat: null,
                  lng: null,
                  google: {},
                  opta: {},
                  openingHours: [],
                  images: [],
                },
              },
            ],
            details: {
              lat: null,
              lng: null,
              google: {},
              opta: {},
              openingHours: [],
              images: [],
            },
          },
        ],
        details: {
          lat: null,
          lng: null,
          google: {},
          opta: {},
          openingHours: [],
          images: [],
        },
      },
    ],
    details: {
      lat: null,
      lng: null,
      google: {},
      opta: {},
      openingHours: [],
      images: [],
    },
  },
  {
    questionInstance: {
      id: '72488',
      apiName: 'beneficiary_information',
      displayName: 'Beneficiary Information',
      label: 'Beneficiary Information',
      helpText: null,
      component: 'repeatable',
      dataType: 'nested',
      propsBlob: {},
      required: false,
      askOnRenewal: false,
      prefillOnRenewal: false,
      subQuestions: [
        {
          id: '72489',
          apiName: 'primary_beneficiaries',
          displayName: 'Primary Beneficiaries',
          label: 'Primary Beneficiaries',
          helpText:
            "This is the first person(s) in line to receive the life insurance payout when you pass away. If there's one beneficiary, they get 100%. If multiple, the payout is split according to the percentages you assign.",
          component: 'repeatable',
          dataType: 'nested',
          propsBlob: {
            repeatable: true,
          },
          required: false,
          askOnRenewal: false,
          prefillOnRenewal: false,
          subQuestions: [
            {
              id: '72490',
              apiName: 'full_name',
              displayName: 'Full Name',
              label: 'Full Name',
              helpText: null,
              component: 'textfield',
              dataType: 'string',
              propsBlob: {},
              required: true,
              askOnRenewal: false,
              prefillOnRenewal: false,
              subQuestions: [],
              defaultValue: '',
            },
            {
              id: '72491',
              apiName: 'primary_beneficiary_date_of_birth',
              displayName: 'Primary Beneficiary Date of Birth',
              label: 'Date of Birth',
              helpText: null,
              component: 'calendar',
              dataType: 'string',
              propsBlob: {},
              required: true,
              askOnRenewal: false,
              prefillOnRenewal: false,
              subQuestions: [],
              defaultValue: '',
            },
            {
              id: '72492',
              apiName: 'relationship_conditional',
              displayName: 'Relationship Conditional',
              label: 'Relationship Conditional',
              helpText: null,
              component: 'logic',
              dataType: 'nested',
              propsBlob: {
                operator: 'equals',
                condition: 'other',
              },
              required: false,
              askOnRenewal: false,
              prefillOnRenewal: false,
              subQuestions: [
                {
                  id: '72493',
                  apiName: 'relationship',
                  displayName: 'Relationship',
                  label: 'Relationship',
                  helpText: null,
                  component: 'InputToggle',
                  dataType: 'string',
                  propsBlob: {
                    options: [
                      {
                        value: 'Spouse',
                        label: 'Spouse',
                      },
                      {
                        value: 'Ex-Spouse',
                        label: 'Ex-Spouse',
                      },
                      {
                        value: 'Father',
                        label: 'Father',
                      },
                      {
                        value: 'Mother',
                        label: 'Mother',
                      },
                      {
                        value: 'Brother',
                        label: 'Brother',
                      },
                      {
                        value: 'Sister',
                        label: 'Sister',
                      },
                      {
                        value: 'Son',
                        label: 'Son',
                      },
                      {
                        value: 'Daughter',
                        label: 'Daughter',
                      },
                      {
                        value: 'other',
                        label: 'Other',
                      },
                    ],
                  },
                  required: true,
                  askOnRenewal: false,
                  prefillOnRenewal: false,
                  subQuestions: [],
                  defaultValue: '',
                },
                {
                  id: '72494',
                  apiName: 'relationship_other',
                  displayName: 'Relationship Other',
                  label: 'Relationship',
                  helpText: null,
                  component: 'textfield',
                  dataType: 'string',
                  propsBlob: {},
                  required: true,
                  askOnRenewal: false,
                  prefillOnRenewal: false,
                  subQuestions: [],
                  defaultValue: '',
                },
              ],
              defaultValue: '',
            },
            {
              id: '72495',
              apiName: 'share',
              displayName: 'Share',
              label: 'Share',
              helpText: null,
              component: 'numberinput',
              dataType: 'number',
              propsBlob: {
                dataType: '%',
              },
              required: true,
              askOnRenewal: false,
              prefillOnRenewal: false,
              subQuestions: [],
              defaultValue: '',
            },
          ],
          defaultValue: '',
        },
        {
          id: '72496',
          apiName: 'contingent_beneficiaries_conditional',
          displayName: 'Contingent Beneficiaries Conditional',
          label: 'Contingent Beneficiaries Conditional',
          helpText: null,
          component: 'logic',
          dataType: 'nested',
          propsBlob: {
            operator: 'equals',
            condition: 'yes',
          },
          required: false,
          askOnRenewal: false,
          prefillOnRenewal: false,
          subQuestions: [
            {
              id: '72497',
              apiName: 'contingent_beneficiaries_boolean',
              displayName: 'Contingent Beneficiaries Boolean',
              label: 'Would you like to add a contingent beneficiary?',
              helpText:
                'Contingent beneficiaries only receive the payout if all primary beneficiaries have passed away. If no contingent beneficiaries are named or alive, the payout goes to your estate and is distributed by your will—or by provincial law if no will exists.',
              component: 'YesNoToggle',
              dataType: 'string',
              propsBlob: {
                options: [
                  {
                    value: 'yes',
                    label: 'Yes',
                  },
                  {
                    value: 'no',
                    label: 'No',
                  },
                ],
              },
              required: true,
              askOnRenewal: false,
              prefillOnRenewal: false,
              subQuestions: [],
              defaultValue: '',
            },
            {
              id: '72498',
              apiName: 'contingent_beneficiaries',
              displayName: 'Contingent Beneficiaries',
              label: 'Contingent Beneficiaries',
              helpText: null,
              component: 'repeatable',
              dataType: 'nested',
              propsBlob: {
                repeatable: true,
              },
              required: false,
              askOnRenewal: false,
              prefillOnRenewal: false,
              subQuestions: [
                {
                  id: '72499',
                  apiName: 'full_name',
                  displayName: 'Full Name',
                  label: 'Full Name',
                  helpText: null,
                  component: 'textfield',
                  dataType: 'string',
                  propsBlob: {},
                  required: true,
                  askOnRenewal: false,
                  prefillOnRenewal: false,
                  subQuestions: [],
                  defaultValue: '',
                },
                {
                  id: '72500',
                  apiName: 'contingent_beneficiary_date_of_birth',
                  displayName: 'Contingent Beneficiary Date of Birth',
                  label: 'Date of Birth',
                  helpText: null,
                  component: 'calendar',
                  dataType: 'string',
                  propsBlob: {},
                  required: true,
                  askOnRenewal: false,
                  prefillOnRenewal: false,
                  subQuestions: [],
                  defaultValue: '',
                },
                {
                  id: '72501',
                  apiName: 'relationship_conditional',
                  displayName: 'Relationship Conditional',
                  label: 'Relationship Conditional',
                  helpText: null,
                  component: 'logic',
                  dataType: 'nested',
                  propsBlob: {
                    operator: 'equals',
                    condition: 'other',
                  },
                  required: false,
                  askOnRenewal: false,
                  prefillOnRenewal: false,
                  subQuestions: [
                    {
                      id: '72502',
                      apiName: 'relationship',
                      displayName: 'Relationship',
                      label: 'Relationship',
                      helpText: null,
                      component: 'InputToggle',
                      dataType: 'string',
                      propsBlob: {
                        options: [
                          {
                            value: 'Spouse',
                            label: 'Spouse',
                          },
                          {
                            value: 'Ex-Spouse',
                            label: 'Ex-Spouse',
                          },
                          {
                            value: 'Father',
                            label: 'Father',
                          },
                          {
                            value: 'Mother',
                            label: 'Mother',
                          },
                          {
                            value: 'Brother',
                            label: 'Brother',
                          },
                          {
                            value: 'Sister',
                            label: 'Sister',
                          },
                          {
                            value: 'Son',
                            label: 'Son',
                          },
                          {
                            value: 'Daughter',
                            label: 'Daughter',
                          },
                          {
                            value: 'other',
                            label: 'Other',
                          },
                        ],
                      },
                      required: true,
                      askOnRenewal: false,
                      prefillOnRenewal: false,
                      subQuestions: [],
                      defaultValue: '',
                    },
                    {
                      id: '72503',
                      apiName: 'relationship_other',
                      displayName: 'Relationship Other',
                      label: 'Relationship',
                      helpText: null,
                      component: 'textfield',
                      dataType: 'string',
                      propsBlob: {},
                      required: true,
                      askOnRenewal: false,
                      prefillOnRenewal: false,
                      subQuestions: [],
                      defaultValue: '',
                    },
                  ],
                  defaultValue: '',
                },
                {
                  id: '72504',
                  apiName: 'share',
                  displayName: 'Share',
                  label: 'Share',
                  helpText: null,
                  component: 'numberinput',
                  dataType: 'number',
                  propsBlob: {
                    dataType: '%',
                  },
                  required: true,
                  askOnRenewal: false,
                  prefillOnRenewal: false,
                  subQuestions: [],
                  defaultValue: '',
                },
              ],
              defaultValue: '',
            },
          ],
          defaultValue: '',
        },
        {
          id: '72505',
          apiName: 'trustee_conditional',
          displayName: 'Trustee Conditional',
          label: 'Trustee Conditional',
          helpText: null,
          component: 'logic',
          dataType: 'nested',
          propsBlob: {
            operator: 'equals',
            condition: 'yes',
          },
          required: false,
          askOnRenewal: false,
          prefillOnRenewal: false,
          subQuestions: [
            {
              id: '72506',
              apiName: 'beneficiaries_minor_boolean',
              displayName: 'Beneficiaries Minor Boolean',
              label: 'Are any primary or contingent beneficiaries a minor?',
              helpText:
                "If any beneficiary is under the age of majority, you must name a trustee. The trustee manages the funds until the minor reaches adulthood, at which point they'll receive the money (plus any investment growth).",
              component: 'YesNoToggle',
              dataType: 'string',
              propsBlob: {
                options: [
                  {
                    value: 'yes',
                    label: 'Yes',
                  },
                  {
                    value: 'no',
                    label: 'No',
                  },
                ],
              },
              required: true,
              askOnRenewal: false,
              prefillOnRenewal: false,
              subQuestions: [],
              defaultValue: '',
            },
            {
              id: '72507',
              apiName: 'trustee_full_name',
              displayName: 'Trustee Full Name',
              label:
                'Name a trustee to manage the proceeds of life insurance until the beneficiary reaches the age of majority',
              helpText: null,
              component: 'textfield',
              dataType: 'string',
              propsBlob: {},
              required: true,
              askOnRenewal: false,
              prefillOnRenewal: false,
              subQuestions: [],
              defaultValue: '',
            },
          ],
          defaultValue: '',
        },
      ],
      defaultValue: '',
    },
    value: 1,
    subAnswers: [
      {
        questionInstance: {
          id: '72489',
          apiName: 'primary_beneficiaries',
          displayName: 'Primary Beneficiaries',
          label: 'Primary Beneficiaries',
          helpText:
            "This is the first person(s) in line to receive the life insurance payout when you pass away. If there's one beneficiary, they get 100%. If multiple, the payout is split according to the percentages you assign.",
          component: 'repeatable',
          dataType: 'nested',
          propsBlob: {
            repeatable: true,
          },
          required: false,
          askOnRenewal: false,
          prefillOnRenewal: false,
          subQuestions: [
            {
              id: '72490',
              apiName: 'full_name',
              displayName: 'Full Name',
              label: 'Full Name',
              helpText: null,
              component: 'textfield',
              dataType: 'string',
              propsBlob: {},
              required: true,
              askOnRenewal: false,
              prefillOnRenewal: false,
              subQuestions: [],
              defaultValue: '',
            },
            {
              id: '72491',
              apiName: 'primary_beneficiary_date_of_birth',
              displayName: 'Primary Beneficiary Date of Birth',
              label: 'Date of Birth',
              helpText: null,
              component: 'calendar',
              dataType: 'string',
              propsBlob: {},
              required: true,
              askOnRenewal: false,
              prefillOnRenewal: false,
              subQuestions: [],
              defaultValue: '',
            },
            {
              id: '72492',
              apiName: 'relationship_conditional',
              displayName: 'Relationship Conditional',
              label: 'Relationship Conditional',
              helpText: null,
              component: 'logic',
              dataType: 'nested',
              propsBlob: {
                operator: 'equals',
                condition: 'other',
              },
              required: false,
              askOnRenewal: false,
              prefillOnRenewal: false,
              subQuestions: [
                {
                  id: '72493',
                  apiName: 'relationship',
                  displayName: 'Relationship',
                  label: 'Relationship',
                  helpText: null,
                  component: 'InputToggle',
                  dataType: 'string',
                  propsBlob: {
                    options: [
                      {
                        value: 'Spouse',
                        label: 'Spouse',
                      },
                      {
                        value: 'Ex-Spouse',
                        label: 'Ex-Spouse',
                      },
                      {
                        value: 'Father',
                        label: 'Father',
                      },
                      {
                        value: 'Mother',
                        label: 'Mother',
                      },
                      {
                        value: 'Brother',
                        label: 'Brother',
                      },
                      {
                        value: 'Sister',
                        label: 'Sister',
                      },
                      {
                        value: 'Son',
                        label: 'Son',
                      },
                      {
                        value: 'Daughter',
                        label: 'Daughter',
                      },
                      {
                        value: 'other',
                        label: 'Other',
                      },
                    ],
                  },
                  required: true,
                  askOnRenewal: false,
                  prefillOnRenewal: false,
                  subQuestions: [],
                  defaultValue: '',
                },
                {
                  id: '72494',
                  apiName: 'relationship_other',
                  displayName: 'Relationship Other',
                  label: 'Relationship',
                  helpText: null,
                  component: 'textfield',
                  dataType: 'string',
                  propsBlob: {},
                  required: true,
                  askOnRenewal: false,
                  prefillOnRenewal: false,
                  subQuestions: [],
                  defaultValue: '',
                },
              ],
              defaultValue: '',
            },
            {
              id: '72495',
              apiName: 'share',
              displayName: 'Share',
              label: 'Share',
              helpText: null,
              component: 'numberinput',
              dataType: 'number',
              propsBlob: {
                dataType: '%',
              },
              required: true,
              askOnRenewal: false,
              prefillOnRenewal: false,
              subQuestions: [],
              defaultValue: '',
            },
          ],
          defaultValue: '',
        },
        value: 1,
        subAnswers: [
          {
            questionInstance: {
              id: '72490',
              apiName: 'full_name',
              displayName: 'Full Name',
              label: 'Full Name',
              helpText: null,
              component: 'textfield',
              dataType: 'string',
              propsBlob: {},
              required: true,
              askOnRenewal: false,
              prefillOnRenewal: false,
              subQuestions: [],
              defaultValue: '',
            },
            value: 'Jane Fonda',
            subAnswers: [],
            details: {
              lat: null,
              lng: null,
              google: {},
              opta: {},
              openingHours: [],
              images: [],
            },
          },
          {
            questionInstance: {
              id: '72491',
              apiName: 'primary_beneficiary_date_of_birth',
              displayName: 'Primary Beneficiary Date of Birth',
              label: 'Date of Birth',
              helpText: null,
              component: 'calendar',
              dataType: 'string',
              propsBlob: {},
              required: true,
              askOnRenewal: false,
              prefillOnRenewal: false,
              subQuestions: [],
              defaultValue: '',
            },
            value: '07/06/1981',
            subAnswers: [],
            details: {
              lat: null,
              lng: null,
              google: {},
              opta: {},
              openingHours: [],
              images: [],
            },
          },
          {
            questionInstance: {
              id: '72492',
              apiName: 'relationship_conditional',
              displayName: 'Relationship Conditional',
              label: 'Relationship Conditional',
              helpText: null,
              component: 'logic',
              dataType: 'nested',
              propsBlob: {
                operator: 'equals',
                condition: 'other',
              },
              required: false,
              askOnRenewal: false,
              prefillOnRenewal: false,
              subQuestions: [
                {
                  id: '72493',
                  apiName: 'relationship',
                  displayName: 'Relationship',
                  label: 'Relationship',
                  helpText: null,
                  component: 'InputToggle',
                  dataType: 'string',
                  propsBlob: {
                    options: [
                      {
                        value: 'Spouse',
                        label: 'Spouse',
                      },
                      {
                        value: 'Ex-Spouse',
                        label: 'Ex-Spouse',
                      },
                      {
                        value: 'Father',
                        label: 'Father',
                      },
                      {
                        value: 'Mother',
                        label: 'Mother',
                      },
                      {
                        value: 'Brother',
                        label: 'Brother',
                      },
                      {
                        value: 'Sister',
                        label: 'Sister',
                      },
                      {
                        value: 'Son',
                        label: 'Son',
                      },
                      {
                        value: 'Daughter',
                        label: 'Daughter',
                      },
                      {
                        value: 'other',
                        label: 'Other',
                      },
                    ],
                  },
                  required: true,
                  askOnRenewal: false,
                  prefillOnRenewal: false,
                  subQuestions: [],
                  defaultValue: '',
                },
                {
                  id: '72494',
                  apiName: 'relationship_other',
                  displayName: 'Relationship Other',
                  label: 'Relationship',
                  helpText: null,
                  component: 'textfield',
                  dataType: 'string',
                  propsBlob: {},
                  required: true,
                  askOnRenewal: false,
                  prefillOnRenewal: false,
                  subQuestions: [],
                  defaultValue: '',
                },
              ],
              defaultValue: '',
            },
            value: '1',
            subAnswers: [
              {
                questionInstance: {
                  id: '72493',
                  apiName: 'relationship',
                  displayName: 'Relationship',
                  label: 'Relationship',
                  helpText: null,
                  component: 'InputToggle',
                  dataType: 'string',
                  propsBlob: {
                    options: [
                      {
                        value: 'Spouse',
                        label: 'Spouse',
                      },
                      {
                        value: 'Ex-Spouse',
                        label: 'Ex-Spouse',
                      },
                      {
                        value: 'Father',
                        label: 'Father',
                      },
                      {
                        value: 'Mother',
                        label: 'Mother',
                      },
                      {
                        value: 'Brother',
                        label: 'Brother',
                      },
                      {
                        value: 'Sister',
                        label: 'Sister',
                      },
                      {
                        value: 'Son',
                        label: 'Son',
                      },
                      {
                        value: 'Daughter',
                        label: 'Daughter',
                      },
                      {
                        value: 'other',
                        label: 'Other',
                      },
                    ],
                  },
                  required: true,
                  askOnRenewal: false,
                  prefillOnRenewal: false,
                  subQuestions: [],
                  defaultValue: '',
                },
                value: 'Spouse',
                subAnswers: [],
                details: {
                  lat: null,
                  lng: null,
                  google: {},
                  opta: {},
                  openingHours: [],
                  images: [],
                },
              },
            ],
            details: {
              lat: null,
              lng: null,
              google: {},
              opta: {},
              openingHours: [],
              images: [],
            },
          },
          {
            questionInstance: {
              id: '72495',
              apiName: 'share',
              displayName: 'Share',
              label: 'Share',
              helpText: null,
              component: 'numberinput',
              dataType: 'number',
              propsBlob: {
                dataType: '%',
              },
              required: true,
              askOnRenewal: false,
              prefillOnRenewal: false,
              subQuestions: [],
              defaultValue: '',
            },
            value: '100',
            subAnswers: [],
            details: {
              lat: null,
              lng: null,
              google: {},
              opta: {},
              openingHours: [],
              images: [],
            },
          },
        ],
        details: {
          lat: null,
          lng: null,
          google: {},
          opta: {},
          openingHours: [],
          images: [],
        },
      },
      {
        questionInstance: {
          id: '72496',
          apiName: 'contingent_beneficiaries_conditional',
          displayName: 'Contingent Beneficiaries Conditional',
          label: 'Contingent Beneficiaries Conditional',
          helpText: null,
          component: 'logic',
          dataType: 'nested',
          propsBlob: {
            operator: 'equals',
            condition: 'yes',
          },
          required: false,
          askOnRenewal: false,
          prefillOnRenewal: false,
          subQuestions: [
            {
              id: '72497',
              apiName: 'contingent_beneficiaries_boolean',
              displayName: 'Contingent Beneficiaries Boolean',
              label: 'Would you like to add a contingent beneficiary?',
              helpText:
                'Contingent beneficiaries only receive the payout if all primary beneficiaries have passed away. If no contingent beneficiaries are named or alive, the payout goes to your estate and is distributed by your will—or by provincial law if no will exists.',
              component: 'YesNoToggle',
              dataType: 'string',
              propsBlob: {
                options: [
                  {
                    value: 'yes',
                    label: 'Yes',
                  },
                  {
                    value: 'no',
                    label: 'No',
                  },
                ],
              },
              required: true,
              askOnRenewal: false,
              prefillOnRenewal: false,
              subQuestions: [],
              defaultValue: '',
            },
            {
              id: '72498',
              apiName: 'contingent_beneficiaries',
              displayName: 'Contingent Beneficiaries',
              label: 'Contingent Beneficiaries',
              helpText: null,
              component: 'repeatable',
              dataType: 'nested',
              propsBlob: {
                repeatable: true,
              },
              required: false,
              askOnRenewal: false,
              prefillOnRenewal: false,
              subQuestions: [
                {
                  id: '72499',
                  apiName: 'full_name',
                  displayName: 'Full Name',
                  label: 'Full Name',
                  helpText: null,
                  component: 'textfield',
                  dataType: 'string',
                  propsBlob: {},
                  required: true,
                  askOnRenewal: false,
                  prefillOnRenewal: false,
                  subQuestions: [],
                  defaultValue: '',
                },
                {
                  id: '72500',
                  apiName: 'contingent_beneficiary_date_of_birth',
                  displayName: 'Contingent Beneficiary Date of Birth',
                  label: 'Date of Birth',
                  helpText: null,
                  component: 'calendar',
                  dataType: 'string',
                  propsBlob: {},
                  required: true,
                  askOnRenewal: false,
                  prefillOnRenewal: false,
                  subQuestions: [],
                  defaultValue: '',
                },
                {
                  id: '72501',
                  apiName: 'relationship_conditional',
                  displayName: 'Relationship Conditional',
                  label: 'Relationship Conditional',
                  helpText: null,
                  component: 'logic',
                  dataType: 'nested',
                  propsBlob: {
                    operator: 'equals',
                    condition: 'other',
                  },
                  required: false,
                  askOnRenewal: false,
                  prefillOnRenewal: false,
                  subQuestions: [
                    {
                      id: '72502',
                      apiName: 'relationship',
                      displayName: 'Relationship',
                      label: 'Relationship',
                      helpText: null,
                      component: 'InputToggle',
                      dataType: 'string',
                      propsBlob: {
                        options: [
                          {
                            value: 'Spouse',
                            label: 'Spouse',
                          },
                          {
                            value: 'Ex-Spouse',
                            label: 'Ex-Spouse',
                          },
                          {
                            value: 'Father',
                            label: 'Father',
                          },
                          {
                            value: 'Mother',
                            label: 'Mother',
                          },
                          {
                            value: 'Brother',
                            label: 'Brother',
                          },
                          {
                            value: 'Sister',
                            label: 'Sister',
                          },
                          {
                            value: 'Son',
                            label: 'Son',
                          },
                          {
                            value: 'Daughter',
                            label: 'Daughter',
                          },
                          {
                            value: 'other',
                            label: 'Other',
                          },
                        ],
                      },
                      required: true,
                      askOnRenewal: false,
                      prefillOnRenewal: false,
                      subQuestions: [],
                      defaultValue: '',
                    },
                    {
                      id: '72503',
                      apiName: 'relationship_other',
                      displayName: 'Relationship Other',
                      label: 'Relationship',
                      helpText: null,
                      component: 'textfield',
                      dataType: 'string',
                      propsBlob: {},
                      required: true,
                      askOnRenewal: false,
                      prefillOnRenewal: false,
                      subQuestions: [],
                      defaultValue: '',
                    },
                  ],
                  defaultValue: '',
                },
                {
                  id: '72504',
                  apiName: 'share',
                  displayName: 'Share',
                  label: 'Share',
                  helpText: null,
                  component: 'numberinput',
                  dataType: 'number',
                  propsBlob: {
                    dataType: '%',
                  },
                  required: true,
                  askOnRenewal: false,
                  prefillOnRenewal: false,
                  subQuestions: [],
                  defaultValue: '',
                },
              ],
              defaultValue: '',
            },
          ],
          defaultValue: '',
        },
        value: '1',
        subAnswers: [
          {
            questionInstance: {
              id: '72497',
              apiName: 'contingent_beneficiaries_boolean',
              displayName: 'Contingent Beneficiaries Boolean',
              label: 'Would you like to add a contingent beneficiary?',
              helpText:
                'Contingent beneficiaries only receive the payout if all primary beneficiaries have passed away. If no contingent beneficiaries are named or alive, the payout goes to your estate and is distributed by your will—or by provincial law if no will exists.',
              component: 'YesNoToggle',
              dataType: 'string',
              propsBlob: {
                options: [
                  {
                    value: 'yes',
                    label: 'Yes',
                  },
                  {
                    value: 'no',
                    label: 'No',
                  },
                ],
              },
              required: true,
              askOnRenewal: false,
              prefillOnRenewal: false,
              subQuestions: [],
              defaultValue: '',
            },
            value: 'yes',
            subAnswers: [],
            details: {
              lat: null,
              lng: null,
              google: {},
              opta: {},
              openingHours: [],
              images: [],
            },
          },
          {
            questionInstance: {
              id: '72498',
              apiName: 'contingent_beneficiaries',
              displayName: 'Contingent Beneficiaries',
              label: 'Contingent Beneficiaries',
              helpText: null,
              component: 'repeatable',
              dataType: 'nested',
              propsBlob: {
                repeatable: true,
              },
              required: false,
              askOnRenewal: false,
              prefillOnRenewal: false,
              subQuestions: [
                {
                  id: '72499',
                  apiName: 'full_name',
                  displayName: 'Full Name',
                  label: 'Full Name',
                  helpText: null,
                  component: 'textfield',
                  dataType: 'string',
                  propsBlob: {},
                  required: true,
                  askOnRenewal: false,
                  prefillOnRenewal: false,
                  subQuestions: [],
                  defaultValue: '',
                },
                {
                  id: '72500',
                  apiName: 'contingent_beneficiary_date_of_birth',
                  displayName: 'Contingent Beneficiary Date of Birth',
                  label: 'Date of Birth',
                  helpText: null,
                  component: 'calendar',
                  dataType: 'string',
                  propsBlob: {},
                  required: true,
                  askOnRenewal: false,
                  prefillOnRenewal: false,
                  subQuestions: [],
                  defaultValue: '',
                },
                {
                  id: '72501',
                  apiName: 'relationship_conditional',
                  displayName: 'Relationship Conditional',
                  label: 'Relationship Conditional',
                  helpText: null,
                  component: 'logic',
                  dataType: 'nested',
                  propsBlob: {
                    operator: 'equals',
                    condition: 'other',
                  },
                  required: false,
                  askOnRenewal: false,
                  prefillOnRenewal: false,
                  subQuestions: [
                    {
                      id: '72502',
                      apiName: 'relationship',
                      displayName: 'Relationship',
                      label: 'Relationship',
                      helpText: null,
                      component: 'InputToggle',
                      dataType: 'string',
                      propsBlob: {
                        options: [
                          {
                            value: 'Spouse',
                            label: 'Spouse',
                          },
                          {
                            value: 'Ex-Spouse',
                            label: 'Ex-Spouse',
                          },
                          {
                            value: 'Father',
                            label: 'Father',
                          },
                          {
                            value: 'Mother',
                            label: 'Mother',
                          },
                          {
                            value: 'Brother',
                            label: 'Brother',
                          },
                          {
                            value: 'Sister',
                            label: 'Sister',
                          },
                          {
                            value: 'Son',
                            label: 'Son',
                          },
                          {
                            value: 'Daughter',
                            label: 'Daughter',
                          },
                          {
                            value: 'other',
                            label: 'Other',
                          },
                        ],
                      },
                      required: true,
                      askOnRenewal: false,
                      prefillOnRenewal: false,
                      subQuestions: [],
                      defaultValue: '',
                    },
                    {
                      id: '72503',
                      apiName: 'relationship_other',
                      displayName: 'Relationship Other',
                      label: 'Relationship',
                      helpText: null,
                      component: 'textfield',
                      dataType: 'string',
                      propsBlob: {},
                      required: true,
                      askOnRenewal: false,
                      prefillOnRenewal: false,
                      subQuestions: [],
                      defaultValue: '',
                    },
                  ],
                  defaultValue: '',
                },
                {
                  id: '72504',
                  apiName: 'share',
                  displayName: 'Share',
                  label: 'Share',
                  helpText: null,
                  component: 'numberinput',
                  dataType: 'number',
                  propsBlob: {
                    dataType: '%',
                  },
                  required: true,
                  askOnRenewal: false,
                  prefillOnRenewal: false,
                  subQuestions: [],
                  defaultValue: '',
                },
              ],
              defaultValue: '',
            },
            value: 1,
            subAnswers: [
              {
                questionInstance: {
                  id: '72499',
                  apiName: 'full_name',
                  displayName: 'Full Name',
                  label: 'Full Name',
                  helpText: null,
                  component: 'textfield',
                  dataType: 'string',
                  propsBlob: {},
                  required: true,
                  askOnRenewal: false,
                  prefillOnRenewal: false,
                  subQuestions: [],
                  defaultValue: '',
                },
                value: 'Sally Fonda',
                subAnswers: [],
                details: {
                  lat: null,
                  lng: null,
                  google: {},
                  opta: {},
                  openingHours: [],
                  images: [],
                },
              },
              {
                questionInstance: {
                  id: '72500',
                  apiName: 'contingent_beneficiary_date_of_birth',
                  displayName: 'Contingent Beneficiary Date of Birth',
                  label: 'Date of Birth',
                  helpText: null,
                  component: 'calendar',
                  dataType: 'string',
                  propsBlob: {},
                  required: true,
                  askOnRenewal: false,
                  prefillOnRenewal: false,
                  subQuestions: [],
                  defaultValue: '',
                },
                value: '07/17/2005',
                subAnswers: [],
                details: {
                  lat: null,
                  lng: null,
                  google: {},
                  opta: {},
                  openingHours: [],
                  images: [],
                },
              },
              {
                questionInstance: {
                  id: '72501',
                  apiName: 'relationship_conditional',
                  displayName: 'Relationship Conditional',
                  label: 'Relationship Conditional',
                  helpText: null,
                  component: 'logic',
                  dataType: 'nested',
                  propsBlob: {
                    operator: 'equals',
                    condition: 'other',
                  },
                  required: false,
                  askOnRenewal: false,
                  prefillOnRenewal: false,
                  subQuestions: [
                    {
                      id: '72502',
                      apiName: 'relationship',
                      displayName: 'Relationship',
                      label: 'Relationship',
                      helpText: null,
                      component: 'InputToggle',
                      dataType: 'string',
                      propsBlob: {
                        options: [
                          {
                            value: 'Spouse',
                            label: 'Spouse',
                          },
                          {
                            value: 'Ex-Spouse',
                            label: 'Ex-Spouse',
                          },
                          {
                            value: 'Father',
                            label: 'Father',
                          },
                          {
                            value: 'Mother',
                            label: 'Mother',
                          },
                          {
                            value: 'Brother',
                            label: 'Brother',
                          },
                          {
                            value: 'Sister',
                            label: 'Sister',
                          },
                          {
                            value: 'Son',
                            label: 'Son',
                          },
                          {
                            value: 'Daughter',
                            label: 'Daughter',
                          },
                          {
                            value: 'other',
                            label: 'Other',
                          },
                        ],
                      },
                      required: true,
                      askOnRenewal: false,
                      prefillOnRenewal: false,
                      subQuestions: [],
                      defaultValue: '',
                    },
                    {
                      id: '72503',
                      apiName: 'relationship_other',
                      displayName: 'Relationship Other',
                      label: 'Relationship',
                      helpText: null,
                      component: 'textfield',
                      dataType: 'string',
                      propsBlob: {},
                      required: true,
                      askOnRenewal: false,
                      prefillOnRenewal: false,
                      subQuestions: [],
                      defaultValue: '',
                    },
                  ],
                  defaultValue: '',
                },
                value: '1',
                subAnswers: [
                  {
                    questionInstance: {
                      id: '72502',
                      apiName: 'relationship',
                      displayName: 'Relationship',
                      label: 'Relationship',
                      helpText: null,
                      component: 'InputToggle',
                      dataType: 'string',
                      propsBlob: {
                        options: [
                          {
                            value: 'Spouse',
                            label: 'Spouse',
                          },
                          {
                            value: 'Ex-Spouse',
                            label: 'Ex-Spouse',
                          },
                          {
                            value: 'Father',
                            label: 'Father',
                          },
                          {
                            value: 'Mother',
                            label: 'Mother',
                          },
                          {
                            value: 'Brother',
                            label: 'Brother',
                          },
                          {
                            value: 'Sister',
                            label: 'Sister',
                          },
                          {
                            value: 'Son',
                            label: 'Son',
                          },
                          {
                            value: 'Daughter',
                            label: 'Daughter',
                          },
                          {
                            value: 'other',
                            label: 'Other',
                          },
                        ],
                      },
                      required: true,
                      askOnRenewal: false,
                      prefillOnRenewal: false,
                      subQuestions: [],
                      defaultValue: '',
                    },
                    value: 'Daughter',
                    subAnswers: [],
                    details: {
                      lat: null,
                      lng: null,
                      google: {},
                      opta: {},
                      openingHours: [],
                      images: [],
                    },
                  },
                ],
                details: {
                  lat: null,
                  lng: null,
                  google: {},
                  opta: {},
                  openingHours: [],
                  images: [],
                },
              },
              {
                questionInstance: {
                  id: '72504',
                  apiName: 'share',
                  displayName: 'Share',
                  label: 'Share',
                  helpText: null,
                  component: 'numberinput',
                  dataType: 'number',
                  propsBlob: {
                    dataType: '%',
                  },
                  required: true,
                  askOnRenewal: false,
                  prefillOnRenewal: false,
                  subQuestions: [],
                  defaultValue: '',
                },
                value: '100',
                subAnswers: [],
                details: {
                  lat: null,
                  lng: null,
                  google: {},
                  opta: {},
                  openingHours: [],
                  images: [],
                },
              },
            ],
            details: {
              lat: null,
              lng: null,
              google: {},
              opta: {},
              openingHours: [],
              images: [],
            },
          },
        ],
        details: {
          lat: null,
          lng: null,
          google: {},
          opta: {},
          openingHours: [],
          images: [],
        },
      },
      {
        questionInstance: {
          id: '72505',
          apiName: 'trustee_conditional',
          displayName: 'Trustee Conditional',
          label: 'Trustee Conditional',
          helpText: null,
          component: 'logic',
          dataType: 'nested',
          propsBlob: {
            operator: 'equals',
            condition: 'yes',
          },
          required: false,
          askOnRenewal: false,
          prefillOnRenewal: false,
          subQuestions: [
            {
              id: '72506',
              apiName: 'beneficiaries_minor_boolean',
              displayName: 'Beneficiaries Minor Boolean',
              label: 'Are any primary or contingent beneficiaries a minor?',
              helpText:
                "If any beneficiary is under the age of majority, you must name a trustee. The trustee manages the funds until the minor reaches adulthood, at which point they'll receive the money (plus any investment growth).",
              component: 'YesNoToggle',
              dataType: 'string',
              propsBlob: {
                options: [
                  {
                    value: 'yes',
                    label: 'Yes',
                  },
                  {
                    value: 'no',
                    label: 'No',
                  },
                ],
              },
              required: true,
              askOnRenewal: false,
              prefillOnRenewal: false,
              subQuestions: [],
              defaultValue: '',
            },
            {
              id: '72507',
              apiName: 'trustee_full_name',
              displayName: 'Trustee Full Name',
              label:
                'Name a trustee to manage the proceeds of life insurance until the beneficiary reaches the age of majority',
              helpText: null,
              component: 'textfield',
              dataType: 'string',
              propsBlob: {},
              required: true,
              askOnRenewal: false,
              prefillOnRenewal: false,
              subQuestions: [],
              defaultValue: '',
            },
          ],
          defaultValue: '',
        },
        value: '1',
        subAnswers: [
          {
            questionInstance: {
              id: '72506',
              apiName: 'beneficiaries_minor_boolean',
              displayName: 'Beneficiaries Minor Boolean',
              label: 'Are any primary or contingent beneficiaries a minor?',
              helpText:
                "If any beneficiary is under the age of majority, you must name a trustee. The trustee manages the funds until the minor reaches adulthood, at which point they'll receive the money (plus any investment growth).",
              component: 'YesNoToggle',
              dataType: 'string',
              propsBlob: {
                options: [
                  {
                    value: 'yes',
                    label: 'Yes',
                  },
                  {
                    value: 'no',
                    label: 'No',
                  },
                ],
              },
              required: true,
              askOnRenewal: false,
              prefillOnRenewal: false,
              subQuestions: [],
              defaultValue: '',
            },
            value: 'no',
            subAnswers: [],
            details: {
              lat: null,
              lng: null,
              google: {},
              opta: {},
              openingHours: [],
              images: [],
            },
          },
        ],
        details: {
          lat: null,
          lng: null,
          google: {},
          opta: {},
          openingHours: [],
          images: [],
        },
      },
    ],
    details: {
      lat: null,
      lng: null,
      google: {},
      opta: {},
      openingHours: [],
      images: [],
    },
  },
  {
    questionInstance: {
      id: '72508',
      apiName: 'policy_specific_information',
      displayName: 'Policy-Specific Information',
      label: 'Policy-Specific Information',
      helpText: null,
      component: 'repeatable',
      dataType: 'nested',
      propsBlob: {},
      required: false,
      askOnRenewal: false,
      prefillOnRenewal: false,
      subQuestions: [
        {
          id: '72509',
          apiName: 'purpose_of_insurance_conditional',
          displayName: 'Purpose of Insurance Conditional',
          label: 'Purpose of Insurance Conditional',
          helpText: null,
          component: 'logic',
          dataType: 'nested',
          propsBlob: {
            operator: 'equals',
            condition: 'personal',
          },
          required: false,
          askOnRenewal: false,
          prefillOnRenewal: false,
          subQuestions: [
            {
              id: '72510',
              apiName: 'purpose_of_insurance',
              displayName: 'Purpose of Insurance',
              label: 'Purpose of Insurance',
              helpText: null,
              component: 'InputToggle',
              dataType: 'string',
              propsBlob: {
                options: [
                  {
                    value: 'personal',
                    label: 'Personal',
                  },
                  {
                    value: 'business',
                    label: 'Business',
                  },
                ],
              },
              required: true,
              askOnRenewal: false,
              prefillOnRenewal: false,
              subQuestions: [],
              defaultValue: '',
            },
            {
              id: '72511',
              apiName: 'personal_insurance_subtype',
              displayName: 'Personal Insurance Subtype',
              label: 'Additional Details',
              helpText: null,
              component: 'InputToggle',
              dataType: 'string',
              propsBlob: {
                options: [
                  {
                    value: 'Mortgage/Debt Protection',
                    label: 'Mortgage/Debt Protection',
                  },
                  {
                    value: 'Income/Family Protection',
                    label: 'Income/Family Protection',
                  },
                  {
                    value: 'Education/Retirement/Investment',
                    label: 'Education/Retirement/Investment',
                  },
                ],
              },
              required: true,
              askOnRenewal: false,
              prefillOnRenewal: false,
              subQuestions: [],
              defaultValue: '',
            },
          ],
          defaultValue: '',
        },
      ],
      defaultValue: '',
    },
    value: 1,
    subAnswers: [
      {
        questionInstance: {
          id: '72509',
          apiName: 'purpose_of_insurance_conditional',
          displayName: 'Purpose of Insurance Conditional',
          label: 'Purpose of Insurance Conditional',
          helpText: null,
          component: 'logic',
          dataType: 'nested',
          propsBlob: {
            operator: 'equals',
            condition: 'personal',
          },
          required: false,
          askOnRenewal: false,
          prefillOnRenewal: false,
          subQuestions: [
            {
              id: '72510',
              apiName: 'purpose_of_insurance',
              displayName: 'Purpose of Insurance',
              label: 'Purpose of Insurance',
              helpText: null,
              component: 'InputToggle',
              dataType: 'string',
              propsBlob: {
                options: [
                  {
                    value: 'personal',
                    label: 'Personal',
                  },
                  {
                    value: 'business',
                    label: 'Business',
                  },
                ],
              },
              required: true,
              askOnRenewal: false,
              prefillOnRenewal: false,
              subQuestions: [],
              defaultValue: '',
            },
            {
              id: '72511',
              apiName: 'personal_insurance_subtype',
              displayName: 'Personal Insurance Subtype',
              label: 'Additional Details',
              helpText: null,
              component: 'InputToggle',
              dataType: 'string',
              propsBlob: {
                options: [
                  {
                    value: 'Mortgage/Debt Protection',
                    label: 'Mortgage/Debt Protection',
                  },
                  {
                    value: 'Income/Family Protection',
                    label: 'Income/Family Protection',
                  },
                  {
                    value: 'Education/Retirement/Investment',
                    label: 'Education/Retirement/Investment',
                  },
                ],
              },
              required: true,
              askOnRenewal: false,
              prefillOnRenewal: false,
              subQuestions: [],
              defaultValue: '',
            },
          ],
          defaultValue: '',
        },
        value: '1',
        subAnswers: [
          {
            questionInstance: {
              id: '72510',
              apiName: 'purpose_of_insurance',
              displayName: 'Purpose of Insurance',
              label: 'Purpose of Insurance',
              helpText: null,
              component: 'InputToggle',
              dataType: 'string',
              propsBlob: {
                options: [
                  {
                    value: 'personal',
                    label: 'Personal',
                  },
                  {
                    value: 'business',
                    label: 'Business',
                  },
                ],
              },
              required: true,
              askOnRenewal: false,
              prefillOnRenewal: false,
              subQuestions: [],
              defaultValue: '',
            },
            value: 'personal',
            subAnswers: [],
            details: {
              lat: null,
              lng: null,
              google: {},
              opta: {},
              openingHours: [],
              images: [],
            },
          },
          {
            questionInstance: {
              id: '72511',
              apiName: 'personal_insurance_subtype',
              displayName: 'Personal Insurance Subtype',
              label: 'Additional Details',
              helpText: null,
              component: 'InputToggle',
              dataType: 'string',
              propsBlob: {
                options: [
                  {
                    value: 'Mortgage/Debt Protection',
                    label: 'Mortgage/Debt Protection',
                  },
                  {
                    value: 'Income/Family Protection',
                    label: 'Income/Family Protection',
                  },
                  {
                    value: 'Education/Retirement/Investment',
                    label: 'Education/Retirement/Investment',
                  },
                ],
              },
              required: true,
              askOnRenewal: false,
              prefillOnRenewal: false,
              subQuestions: [],
              defaultValue: '',
            },
            value: 'Income/Family Protection',
            subAnswers: [],
            details: {
              lat: null,
              lng: null,
              google: {},
              opta: {},
              openingHours: [],
              images: [],
            },
          },
        ],
        details: {
          lat: null,
          lng: null,
          google: {},
          opta: {},
          openingHours: [],
          images: [],
        },
      },
    ],
    details: {
      lat: null,
      lng: null,
      google: {},
      opta: {},
      openingHours: [],
      images: [],
    },
  },
  {
    questionInstance: {
      id: '72512',
      apiName: 'banking_information',
      displayName: 'Banking Information',
      label: 'Banking Information',
      helpText:
        "Providing your bank info won't trigger a payment. You can cancel anytime without penalty, and if your policy isn't approved, no charges will be made.",
      component: 'repeatable',
      dataType: 'nested',
      propsBlob: {},
      required: false,
      askOnRenewal: false,
      prefillOnRenewal: false,
      subQuestions: [
        {
          id: '72513',
          apiName: 'name_of_bank_conditional',
          displayName: 'Name of Bank Conditional',
          label: 'Name of Bank Conditional',
          helpText: null,
          component: 'logic',
          dataType: 'nested',
          propsBlob: {
            operator: 'equals',
            condition: 'other',
          },
          required: false,
          askOnRenewal: false,
          prefillOnRenewal: false,
          subQuestions: [
            {
              id: '72514',
              apiName: 'name_of_bank',
              displayName: 'Name of Bank',
              label: 'Name of Bank',
              helpText: null,
              component: 'InputToggle',
              dataType: 'string',
              propsBlob: {
                options: [
                  {
                    value: 'Bank of Montreal (BMO)',
                    label: 'Bank of Montreal (BMO)',
                  },
                  {
                    value: 'Scotiabank',
                    label: 'Scotiabank',
                  },
                  {
                    value: 'Canadian Imperial Bank of Commerce (CIBC)',
                    label: 'Canadian Imperial Bank of Commerce (CIBC)',
                  },
                  {
                    value: 'Royal Bank of Canada (RBC)',
                    label: 'Royal Bank of Canada (RBC)',
                  },
                  {
                    value: 'Toronto-Dominion Bank (TD)',
                    label: 'Toronto-Dominion Bank (TD)',
                  },
                  {
                    value: 'other',
                    label: 'Other',
                  },
                ],
              },
              required: true,
              askOnRenewal: false,
              prefillOnRenewal: false,
              subQuestions: [],
              defaultValue: '',
            },
            {
              id: '72515',
              apiName: 'name_of_bank_other',
              displayName: 'Name of Bank Other',
              label: 'Name of Bank',
              helpText: null,
              component: 'textfield',
              dataType: 'string',
              propsBlob: {},
              required: true,
              askOnRenewal: false,
              prefillOnRenewal: false,
              subQuestions: [],
              defaultValue: '',
            },
          ],
          defaultValue: '',
        },
        {
          id: '72516',
          apiName: 'institution_number',
          displayName: 'Institution Number',
          label: 'Institution Number (3 digits)',
          helpText: null,
          component: 'textfield',
          dataType: 'string',
          propsBlob: {},
          required: true,
          askOnRenewal: false,
          prefillOnRenewal: false,
          subQuestions: [],
          defaultValue: '',
        },
        {
          id: '72517',
          apiName: 'transit_number',
          displayName: 'Transit Number',
          label: 'Transit Number (5 digits)',
          helpText: null,
          component: 'textfield',
          dataType: 'string',
          propsBlob: {},
          required: true,
          askOnRenewal: false,
          prefillOnRenewal: false,
          subQuestions: [],
          defaultValue: '',
        },
        {
          id: '72518',
          apiName: 'account_number',
          displayName: 'Account Number',
          label: 'Account Number (7 - 12 digits)',
          helpText: null,
          component: 'textfield',
          dataType: 'string',
          propsBlob: {},
          required: true,
          askOnRenewal: false,
          prefillOnRenewal: false,
          subQuestions: [],
          defaultValue: '',
        },
        {
          id: '72519',
          apiName: 'preferred_payment_day',
          displayName: 'Preferred Payment Day',
          label: 'Preferred Payment Day',
          helpText: null,
          component: 'InputToggle',
          dataType: 'string',
          propsBlob: {
            options: [
              {
                value: '1',
                label: '1',
              },
              {
                value: '2',
                label: '2',
              },
              {
                value: '3',
                label: '3',
              },
              {
                value: '4',
                label: '4',
              },
              {
                value: '5',
                label: '5',
              },
              {
                value: '6',
                label: '6',
              },
              {
                value: '7',
                label: '7',
              },
              {
                value: '8',
                label: '8',
              },
              {
                value: '9',
                label: '9',
              },
              {
                value: '10',
                label: '10',
              },
              {
                value: '11',
                label: '11',
              },
              {
                value: '12',
                label: '12',
              },
              {
                value: '13',
                label: '13',
              },
              {
                value: '14',
                label: '14',
              },
              {
                value: '15',
                label: '15',
              },
              {
                value: '16',
                label: '16',
              },
              {
                value: '17',
                label: '17',
              },
              {
                value: '18',
                label: '18',
              },
              {
                value: '19',
                label: '19',
              },
              {
                value: '20',
                label: '20',
              },
              {
                value: '21',
                label: '21',
              },
              {
                value: '22',
                label: '22',
              },
              {
                value: '23',
                label: '23',
              },
              {
                value: '24',
                label: '24',
              },
              {
                value: '25',
                label: '25',
              },
              {
                value: '26',
                label: '26',
              },
              {
                value: '27',
                label: '27',
              },
              {
                value: '28',
                label: '28',
              },
            ],
          },
          required: true,
          askOnRenewal: false,
          prefillOnRenewal: false,
          subQuestions: [],
          defaultValue: '',
        },
      ],
      defaultValue: '',
    },
    value: 1,
    subAnswers: [
      {
        questionInstance: {
          id: '72513',
          apiName: 'name_of_bank_conditional',
          displayName: 'Name of Bank Conditional',
          label: 'Name of Bank Conditional',
          helpText: null,
          component: 'logic',
          dataType: 'nested',
          propsBlob: {
            operator: 'equals',
            condition: 'other',
          },
          required: false,
          askOnRenewal: false,
          prefillOnRenewal: false,
          subQuestions: [
            {
              id: '72514',
              apiName: 'name_of_bank',
              displayName: 'Name of Bank',
              label: 'Name of Bank',
              helpText: null,
              component: 'InputToggle',
              dataType: 'string',
              propsBlob: {
                options: [
                  {
                    value: 'Bank of Montreal (BMO)',
                    label: 'Bank of Montreal (BMO)',
                  },
                  {
                    value: 'Scotiabank',
                    label: 'Scotiabank',
                  },
                  {
                    value: 'Canadian Imperial Bank of Commerce (CIBC)',
                    label: 'Canadian Imperial Bank of Commerce (CIBC)',
                  },
                  {
                    value: 'Royal Bank of Canada (RBC)',
                    label: 'Royal Bank of Canada (RBC)',
                  },
                  {
                    value: 'Toronto-Dominion Bank (TD)',
                    label: 'Toronto-Dominion Bank (TD)',
                  },
                  {
                    value: 'other',
                    label: 'Other',
                  },
                ],
              },
              required: true,
              askOnRenewal: false,
              prefillOnRenewal: false,
              subQuestions: [],
              defaultValue: '',
            },
            {
              id: '72515',
              apiName: 'name_of_bank_other',
              displayName: 'Name of Bank Other',
              label: 'Name of Bank',
              helpText: null,
              component: 'textfield',
              dataType: 'string',
              propsBlob: {},
              required: true,
              askOnRenewal: false,
              prefillOnRenewal: false,
              subQuestions: [],
              defaultValue: '',
            },
          ],
          defaultValue: '',
        },
        value: '1',
        subAnswers: [
          {
            questionInstance: {
              id: '72514',
              apiName: 'name_of_bank',
              displayName: 'Name of Bank',
              label: 'Name of Bank',
              helpText: null,
              component: 'InputToggle',
              dataType: 'string',
              propsBlob: {
                options: [
                  {
                    value: 'Bank of Montreal (BMO)',
                    label: 'Bank of Montreal (BMO)',
                  },
                  {
                    value: 'Scotiabank',
                    label: 'Scotiabank',
                  },
                  {
                    value: 'Canadian Imperial Bank of Commerce (CIBC)',
                    label: 'Canadian Imperial Bank of Commerce (CIBC)',
                  },
                  {
                    value: 'Royal Bank of Canada (RBC)',
                    label: 'Royal Bank of Canada (RBC)',
                  },
                  {
                    value: 'Toronto-Dominion Bank (TD)',
                    label: 'Toronto-Dominion Bank (TD)',
                  },
                  {
                    value: 'other',
                    label: 'Other',
                  },
                ],
              },
              required: true,
              askOnRenewal: false,
              prefillOnRenewal: false,
              subQuestions: [],
              defaultValue: '',
            },
            value: 'Bank of Montreal (BMO)',
            subAnswers: [],
            details: {
              lat: null,
              lng: null,
              google: {},
              opta: {},
              openingHours: [],
              images: [],
            },
          },
        ],
        details: {
          lat: null,
          lng: null,
          google: {},
          opta: {},
          openingHours: [],
          images: [],
        },
      },
      {
        questionInstance: {
          id: '72516',
          apiName: 'institution_number',
          displayName: 'Institution Number',
          label: 'Institution Number (3 digits)',
          helpText: null,
          component: 'textfield',
          dataType: 'string',
          propsBlob: {},
          required: true,
          askOnRenewal: false,
          prefillOnRenewal: false,
          subQuestions: [],
          defaultValue: '',
        },
        value: '001',
        subAnswers: [],
        details: {
          lat: null,
          lng: null,
          google: {},
          opta: {},
          openingHours: [],
          images: [],
        },
      },
      {
        questionInstance: {
          id: '72517',
          apiName: 'transit_number',
          displayName: 'Transit Number',
          label: 'Transit Number (5 digits)',
          helpText: null,
          component: 'textfield',
          dataType: 'string',
          propsBlob: {},
          required: true,
          askOnRenewal: false,
          prefillOnRenewal: false,
          subQuestions: [],
          defaultValue: '',
        },
        value: '12345',
        subAnswers: [],
        details: {
          lat: null,
          lng: null,
          google: {},
          opta: {},
          openingHours: [],
          images: [],
        },
      },
      {
        questionInstance: {
          id: '72518',
          apiName: 'account_number',
          displayName: 'Account Number',
          label: 'Account Number (7 - 12 digits)',
          helpText: null,
          component: 'textfield',
          dataType: 'string',
          propsBlob: {},
          required: true,
          askOnRenewal: false,
          prefillOnRenewal: false,
          subQuestions: [],
          defaultValue: '',
        },
        value: '65445646',
        subAnswers: [],
        details: {
          lat: null,
          lng: null,
          google: {},
          opta: {},
          openingHours: [],
          images: [],
        },
      },
      {
        questionInstance: {
          id: '72519',
          apiName: 'preferred_payment_day',
          displayName: 'Preferred Payment Day',
          label: 'Preferred Payment Day',
          helpText: null,
          component: 'InputToggle',
          dataType: 'string',
          propsBlob: {
            options: [
              {
                value: '1',
                label: '1',
              },
              {
                value: '2',
                label: '2',
              },
              {
                value: '3',
                label: '3',
              },
              {
                value: '4',
                label: '4',
              },
              {
                value: '5',
                label: '5',
              },
              {
                value: '6',
                label: '6',
              },
              {
                value: '7',
                label: '7',
              },
              {
                value: '8',
                label: '8',
              },
              {
                value: '9',
                label: '9',
              },
              {
                value: '10',
                label: '10',
              },
              {
                value: '11',
                label: '11',
              },
              {
                value: '12',
                label: '12',
              },
              {
                value: '13',
                label: '13',
              },
              {
                value: '14',
                label: '14',
              },
              {
                value: '15',
                label: '15',
              },
              {
                value: '16',
                label: '16',
              },
              {
                value: '17',
                label: '17',
              },
              {
                value: '18',
                label: '18',
              },
              {
                value: '19',
                label: '19',
              },
              {
                value: '20',
                label: '20',
              },
              {
                value: '21',
                label: '21',
              },
              {
                value: '22',
                label: '22',
              },
              {
                value: '23',
                label: '23',
              },
              {
                value: '24',
                label: '24',
              },
              {
                value: '25',
                label: '25',
              },
              {
                value: '26',
                label: '26',
              },
              {
                value: '27',
                label: '27',
              },
              {
                value: '28',
                label: '28',
              },
            ],
          },
          required: true,
          askOnRenewal: false,
          prefillOnRenewal: false,
          subQuestions: [],
          defaultValue: '',
        },
        value: '15',
        subAnswers: [],
        details: {
          lat: null,
          lng: null,
          google: {},
          opta: {},
          openingHours: [],
          images: [],
        },
      },
    ],
    details: {
      lat: null,
      lng: null,
      google: {},
      opta: {},
      openingHours: [],
      images: [],
    },
  },
  {
    questionInstance: {
      id: '72520',
      apiName: 'how_did_you_hear_about_us',
      displayName: 'How did you hear about us?',
      label: 'How did you hear about us?',
      helpText: null,
      component: 'repeatable',
      dataType: 'nested',
      propsBlob: {},
      required: false,
      askOnRenewal: false,
      prefillOnRenewal: false,
      subQuestions: [
        {
          id: '72521',
          apiName: 'google_search_engine',
          displayName: 'Google / Search Engine',
          label: 'Google / Search Engine',
          helpText: null,
          component: 'checkbox',
          dataType: 'boolean',
          propsBlob: {},
          required: false,
          askOnRenewal: false,
          prefillOnRenewal: false,
          subQuestions: [],
          defaultValue: '',
        },
        {
          id: '72522',
          apiName: 'social_media',
          displayName: 'Social Media',
          label: 'Social Media',
          helpText: null,
          component: 'checkbox',
          dataType: 'boolean',
          propsBlob: {},
          required: false,
          askOnRenewal: false,
          prefillOnRenewal: false,
          subQuestions: [],
          defaultValue: '',
        },
        {
          id: '72523',
          apiName: 'friend_or_family_referral',
          displayName: 'Friend or Family Referral',
          label: 'Friend or Family Referral',
          helpText: null,
          component: 'checkbox',
          dataType: 'boolean',
          propsBlob: {},
          required: false,
          askOnRenewal: false,
          prefillOnRenewal: false,
          subQuestions: [],
          defaultValue: '',
        },
        {
          id: '72524',
          apiName: 'advertisement',
          displayName: 'Advertisement',
          label: 'Advertisement',
          helpText: null,
          component: 'checkbox',
          dataType: 'boolean',
          propsBlob: {},
          required: false,
          askOnRenewal: false,
          prefillOnRenewal: false,
          subQuestions: [],
          defaultValue: '',
        },
        {
          id: '72525',
          apiName: 'heard_conditional',
          displayName: 'Heard Conditional',
          label: 'Heard Conditional',
          helpText: null,
          component: 'logic',
          dataType: 'nested',
          propsBlob: {
            operator: 'equals',
            condition: 'true',
          },
          required: false,
          askOnRenewal: false,
          prefillOnRenewal: false,
          subQuestions: [
            {
              id: '72526',
              apiName: 'other',
              displayName: 'other',
              label: 'Other (Please Specify)',
              helpText: null,
              component: 'checkbox',
              dataType: 'boolean',
              propsBlob: {},
              required: false,
              askOnRenewal: false,
              prefillOnRenewal: false,
              subQuestions: [],
              defaultValue: '',
            },
            {
              id: '72527',
              apiName: 'please_specify',
              displayName: 'Please specify',
              label: 'Please specify',
              helpText: null,
              component: 'textfield',
              dataType: 'string',
              propsBlob: {},
              required: false,
              askOnRenewal: false,
              prefillOnRenewal: false,
              subQuestions: [],
              defaultValue: '',
            },
          ],
          defaultValue: '',
        },
      ],
      defaultValue: '',
    },
    value: 1,
    subAnswers: [
      {
        questionInstance: {
          id: '72521',
          apiName: 'google_search_engine',
          displayName: 'Google / Search Engine',
          label: 'Google / Search Engine',
          helpText: null,
          component: 'checkbox',
          dataType: 'boolean',
          propsBlob: {},
          required: false,
          askOnRenewal: false,
          prefillOnRenewal: false,
          subQuestions: [],
          defaultValue: '',
        },
        value: true,
        subAnswers: [],
        details: {
          lat: null,
          lng: null,
          google: {},
          opta: {},
          openingHours: [],
          images: [],
        },
      },
    ],
    details: {
      lat: null,
      lng: null,
      google: {},
      opta: {},
      openingHours: [],
      images: [],
    },
  },
];
